<template>
  <div>
    <page-title
      heading="Registrasi Antrean"
      :breadcrumb="[
        {
          label: 'REGISTRASI ANTREAN',
          link: '/antrean'
        },
        { label: 'registrasi', active: true }
      ]"
    ></page-title>
    <div class="container-fluid" style="zoom:80%">
      <div class="card mb-5">
        <div class="card-header">
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-4">
                  <h4 class="text-capitalize mb-5">form registrasi antrean</h4>
                </div>
                <div class="col-sm-8" v-if="!(isPerawat && isEdit)">
                  <b-button
                    class="text-uppercase"
                    style="font-size:14.5px;float:right;vertical-align: top;"
                    @click="goToPasienBaru()"
                    variant="primary"
                  >
                    Tambah Pasien Baru</b-button
                  >
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="row">
                <div class="col-sm-3">
                  <!-- Kategori -->
                  <vue-select
                    :options="option_kategori"
                    v-model="selectedKategori"
                    placeholder="Pilih Kategori Pasien"
                    :class="
                      isErrorKategori || validateKategori
                        ? '__kategori-select'
                        : '__kategori-select mb-5'
                    "
                    :style="isErrorKategori || validateKategori ? '' : ''"
                    ref="kategori_pasien"
                    :disabled="isEdit && isPerawat"
                  />
                  <div class="invalid_msg mb-5" v-if="isErrorKategori">
                    Harap ubah kategori pasien untuk melanjutkan antrean
                  </div>
                  <div class="invalid_msg mb-5" v-if="validateKategori">
                    Kolom harus diisi
                  </div>
                </div>
                <div class="col-sm-8">
                  <template
                    v-if="selectedKategori && selectedKategori.value == 2"
                  >
                    <div class="row">
                      <div :class="card_number.error ? 'col-sm-4' : 'col-sm-4'">
                        <b-form-input
                          ref="card_number"
                          type="text"
                          v-model="card_number.number"
                          placeholder="Tuliskan nomor BPJS/NIK Peserta"
                          :class="{
                            '__kategori-select is-invalid': card_number.error
                          }"
                          @keypress="onKeyInputNumberBPJS({ $event })"
                          @input="onCardNumber()"
                          :disabled="isPerawat && isEdit"
                        />
                        <b-form-invalid-feedback v-if="card_number.error">
                          {{ card_number.message }}
                        </b-form-invalid-feedback>
                      </div>
                      <div class="col-sm-4" v-if="!(isPerawat && isEdit)">
                        <b-button @click="cekPesertaBPJS()" variant="primary">
                          Cek Keanggotaan</b-button
                        >
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-sm-5">&nbsp;</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="dataBPJSSuccess && !disableDate">
            <b-col sm="12">
              <div class="polaris-card">
                <!-- Info Polaris -->
                <b-row>
                  <b-col sm="3" class="font-weight-bold">
                    <label for="prolanis-name">Nama</label>
                  </b-col>
                  <b-col sm="9">
                    <span class="text-uppercase">{{
                      dataBPJS.detail_peserta.nama || "-"
                    }}</span>
                    <span
                      class="text-danger font-weight-bold"
                      v-if="dataBPJS.detail_peserta.pstProl"
                    >
                      - {{ dataBPJS.detail_peserta.pstProl }}
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3" class="font-weight-bold">
                    <label for="prolanis-name">Status Peserta</label>
                  </b-col>
                  <b-col>
                    <span class="text-uppercase">{{
                      dataBPJS.detail_peserta.hubunganKeluarga || "-"
                    }}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3" class="font-weight-bold">
                    <label for="prolanis-name">Tanggal Lahir</label>
                  </b-col>
                  <b-col>
                    {{ dataBPJS.detail_peserta.tglLahir || "-" }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3" class="font-weight-bold">
                    <label for="prolanis-name">Kelamin</label>
                  </b-col>
                  <b-col>
                    {{
                      dataBPJS.detail_peserta.sex
                        ? dataBPJS.detail_peserta.sex == "L"
                          ? "Laki-laki"
                          : "Perempuan"
                        : "-"
                    }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3" class="font-weight-bold">
                    <label for="prolanis-name">PPK Umum</label>
                  </b-col>
                  <b-col>
                    {{ dataBPJS.detail_peserta.kdProviderPst.kdProvider }}
                    -
                    {{ dataBPJS.detail_peserta.kdProviderPst.nmProvider }}
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3" class="font-weight-bold">
                    <label for="prolanis-name">No Handphone</label>
                  </b-col>
                  <b-col>
                    {{ dataBPJS.detail_peserta.noHP || "-" }}
                  </b-col>
                </b-row>
                <!-- End Info Polaris -->
              </div>
            </b-col>
          </div>
          <div class="row" :class="dataBPJSSuccess ? 'mt-4' : ''">
            <div class="col-sm-3" style="position: relative;">
              <!-- Date -->
              <DatePickerX
                v-model="dataTanggal"
                :max-date="maxDate"
                locale="id"
                :min-date="minDate"
                :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <b-form-input
                    v-if="
                      (selectedKategori && !isErrorKategori && activeBPJS) ||
                        fromJkn
                    "
                    placeholder="Pilih Tanggal Konsultasi"
                    :value="inputValue"
                    v-on="inputEvents"
                    :readonly="true"
                    :style="
                      (isEdit && isPerawat) || (disableDate)
                        ? 'pointer-events: none;'
                        : 'background-color:#ffffff;'
                    "
                    :is-required="true"
                    :class="validateTanggal ? '' : 'mb-3'"
                    ref="tanggal_konsultasi"
                  ></b-form-input>
                  <b-form-input
                    v-else
                    placeholder="Pilih Tanggal Konsultasi"
                    :value="inputValue"
                    v-on="inputEvents"
                    :disabled="true"
                    :is-required="true"
                    :class="validateTanggal ? '' : 'mb-3'"
                    ref="tanggal_konsultasi"
                    :style="
                      (isEdit && isPerawat) || (disableDate)
                        ? 'pointer-events: none;'
                        : 'background-color:#ffffff;'
                    "
                  ></b-form-input>
                  <span
                    v-if="validateTanggal"
                    class="invalid_msg mb-5"
                    style="color:red;font-size:12px"
                    >Kolom harus diisi</span
                  >
                </template>
              </DatePickerX>
              <font-awesome-icon
                icon="calendar"
                :class="
                  isErrorKategori || validateKategori
                    ? 'icon_cal_err'
                    : 'icon_cal'
                "
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <b-form v-on:submit.prevent="submitForm">
            <div class="outer_antrian">
              <b-row class="mt-2 p-4">
                <b-col lg="12" class="mb-3 mt-2">
                  <strong style="font-size:13.4px; color: grey"
                    >Kolom bertanda <span style="color:red">*</span> Wajib di
                    isi</strong
                  >
                  <br />
                </b-col>
                <b-col
                  v-for="form in formBasicData"
                  :sm="form.tmpId < 12 ? form.col : 0"
                  :lg="form.tmpId < 12 ? form.colLg : 0"
                  :key="form.tmpId"
                  :class="form.class"
                  :style="form.tmpId < 12 ? '' : 'display : none;'"
                >
                  <template v-if="form.tmpId < 12">
                    <b-form-group
                      class="text-capitalize"
                      style="position: relative"
                      :state="renderError({ error: form.error })"
                    >
                      <strong style="font-size: 13px; color: grey;">{{
                        setLabel(form.rawLabel)
                      }}</strong>
                      <label style="color:red">{{ form.isImportant }}</label>
                      <template v-if="form.type === 'text'">
                        <b-form-input
                          v-if="
                            !/(badan)/gi.test(form.label) &&
                              ![
                                'tensi sistole',
                                'tensi diastole',
                                'nadi'
                              ].includes(form.rawLabel.toLowerCase()) &&
                              whitelistValidation &&
                              !whitelistValidation().includes(
                                form.rawLabel.toLowerCase()
                              )
                          "
                          type="text"
                          v-model="formData[form.label]"
                          @keyup="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          :state="renderError({ error: form.error })"
                          :disabled="disableInput(form.label)"
                          class="mt-2"
                          :ref="form.label"
                        />
                      </template>
                      <!-- nama pasien -->
                      <div
                        v-if="
                          form.type === 'select' &&
                            form.rawLabel === 'nama pasien'
                        "
                        @mouseover="
                          checkTextOverflow(
                            'selected_option_pasien_div',
                            'ref_popover_nama_pasien'
                          )
                        "
                        @mouseleave="
                          handleMouseLeave('ref_popover_nama_pasien')
                        "
                      >
                        <b-popover
                          :container="'select_nama_pasien'"
                          :target="'select_nama_pasien'"
                          :ref="'ref_popover_nama_pasien'"
                          placement="top"
                          v-if="isPerawat && isEdit"
                        >
                          {{ selectedPasien ? selectedPasien.label : "" }}
                        </b-popover>
                        <vue-select
                          id="select_nama_pasien"
                          :class="{ error: form.error }"
                          :options="options[form.label]"
                          @input="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          class="__antrean-select"
                          placeholder="Tuliskan nama pasien"
                          :filterable="false"
                          @search="debounceSearchPasien"
                          v-model="selectedPasien"
                          ref="nama_pasien"
                          :disabled="isPerawat && isEdit"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.label }}
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div
                              class="no-overflow"
                              ref="selected_option_pasien_div"
                            >
                              {{ option.label }}
                            </div>
                          </template>
                          <!-- slot="no-options" -->
                          <template #no-options="{  searching  }">
                            <span
                              style="color:red;padding:6px; font-size:12px"
                              v-if="searching"
                              >Nama pasien tidak ditemukan, silakan daftarkan
                              pasien sebagai pasien baru</span
                            >
                            <span v-else> tulis nama lengkap pasien</span>
                          </template>
                        </vue-select>
                      </div>
                      <!-- Jenis Kelamin -->
                      <vue-select
                        :class="{ error: form.error }"
                        :options="option_gender"
                        :placeholder="form.placeholder"
                        v-model="selectedGender"
                        class="__antrean-select"
                        v-else-if="
                          form.type === 'select' &&
                            form.label == 'jenis_kelamin'
                        "
                        disabled
                      />
                      <!-- poliklinik -->
                      <div
                        v-else-if="
                          form.type === 'select' && form.label == 'poliklinik'
                        "
                        @mouseover="
                          checkTextOverflow(
                            'selected_option_poliklinik_div',
                            'ref_popover_poliklinik'
                          )
                        "
                        @mouseleave="handleMouseLeave('ref_popover_poliklinik')"
                      >
                        <b-popover
                          :container="'id_select_poliklinik'"
                          :target="'id_select_poliklinik'"
                          :ref="'ref_popover_poliklinik'"
                          placement="top"
                          v-if="isPerawat && isEdit"
                        >
                          {{ selectedPoli ? selectedPoli.label : "" }}
                        </b-popover>
                        <vue-select
                          id="id_select_poliklinik"
                          :class="{ error: form.error }"
                          :options="option_poliklinik"
                          :placeholder="form.placeholder"
                          class="__antrean-select"
                          :disabled="
                            dataTanggal == null || (isEdit && isPerawat)
                          "
                          v-model="selectedPoli"
                          @input="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          :ref="form.label"
                          :selectable="option => !option.disable"
                        >
                          <template slot="selected-option" slot-scope="option">
                            <div
                              class="no-overflow"
                              ref="selected_option_poliklinik_div"
                            >
                              {{ option.label }}
                            </div>
                          </template>
                        </vue-select>
                      </div>
                      <!-- Dokter -->
                      <div
                        v-else-if="
                          form.type === 'select' && form.label == 'nama_dokter'
                        "
                        @mouseover="
                          checkTextOverflow(
                            'selected_option_dokter_div',
                            'ref_popover_dokter'
                          )
                        "
                        @mouseleave="handleMouseLeave('ref_popover_dokter')"
                      >
                        <b-popover
                          :container="'id_select_dokter'"
                          :target="'id_select_dokter'"
                          :ref="'ref_popover_dokter'"
                          placement="top"
                          v-if="isPerawat && isEdit"
                        >
                          <p class="text-capitalize">
                            {{ selectedDokter ? selectedDokter.label : "" }}
                          </p>
                        </b-popover>
                        <vue-select
                          id="id_select_dokter"
                          :class="{ error: form.error }"
                          :options="option_nama_dokter"
                          :placeholder="form.placeholder"
                          v-model="selectedDokter"
                          class="__antrean-select"
                          :disabled="
                            formData.poliklinik == '' || (isEdit && isPerawat)
                          "
                          @input="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          :ref="form.label"
                          :selectable="option => !option.disable"
                          @search:focus="notifOffline('dokter')"
                        >
                          <template #no-options="{}">
                            <span v-if="!isOnline">&nbsp;</span>
                          </template>
                          <template slot="selected-option" slot-scope="option">
                            <div
                              class="no-overflow"
                              ref="selected_option_dokter_div"
                            >
                              {{ option.label }}
                            </div>
                          </template>
                        </vue-select>
                      </div>
                      <!-- Slot -->
                      <vue-select
                        :class="{ error: form.error }"
                        :options="option_slot_waktu"
                        :placeholder="form.placeholder"
                        v-model="selectedSlot"
                        class="__antrean-select"
                        :disabled="
                          formData.nama_dokter == '' ||
                            isCustomSlot ||
                            (isEdit && isPerawat)
                        "
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        v-else-if="
                          form.type === 'select' && form.label == 'slot_waktu'
                        "
                        :ref="form.label"
                        @search:focus="notifOffline('slot')"
                      >
                        <template #no-options="{  searching  }">
                          <span
                            style="color:red;font-size:12px;padding:5px"
                            v-if="searching"
                            >Jadwal tidak tersedia. Silakan pilih tanggal atau
                            dokter lainnya.
                          </span>
                          <span
                            style="color:red;font-size:12px;padding:5px"
                            v-else-if="isOnline"
                            >Jadwal tidak tersedia. Silakan pilih tanggal atau
                            dokter lainnya.
                          </span>
                          <span v-else-if="!isOnline">&nbsp;</span>
                        </template>
                      </vue-select>
                      <!-- Provinsi -->
                      <vue-select
                        :class="{ error: form.error }"
                        :options="option_provinsi"
                        :placeholder="form.placeholder"
                        v-model="selectedProvinsi"
                        class="__antrean-select"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        v-else-if="
                          form.type === 'select' && form.label == 'provinsi'
                        "
                        @search:focus="notifOffline('provinsi')"
                      >
                      </vue-select>
                      <!-- Kabupaten / Kota -->
                      <vue-select
                        id="id_select_kota"
                        :class="{ error: form.error }"
                        :options="option_kota"
                        :placeholder="form.placeholder"
                        v-model="selectedKota"
                        class="__antrean-select"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        v-else-if="
                          form.type === 'select' && form.label == 'kota'
                        "
                        @search:focus="notifOffline('kota')"
                      >
                        <template slot="selected-option" slot-scope="option">
                          <div
                            class="no-overflow"
                            ref="selected_option_kota_div"
                          >
                            {{ option.label }}
                          </div>
                        </template>
                      </vue-select>
                      <template v-if="form.type === 'radio'">
                        <b-form-radio-group
                          id="radio-group-1"
                          v-model="formData[form.label]"
                          @change="
                            setValue({
                              label: form.label,
                              rawLabel: form.rawLabel,
                              $event
                            })
                          "
                          :options="
                            form.data.map((item, index) => ({
                              text: item,
                              value: index
                            }))
                          "
                          name="radio-options"
                          disabled
                        ></b-form-radio-group>
                      </template>
                      <template v-if="form.type == 'textarea'">
                        <b-form-textarea
                          id="textarea"
                          v-model="formData[form.label]"
                          @keyup="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          :placeholder="form.placeholder"
                          :size="form.size"
                          :maxlength="form.maxLength"
                          class="mt-2"
                        >
                        </b-form-textarea>
                      </template>
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: form.error })"
                      >
                        {{
                          /(Handphone)/gi.test(form["validation-desc"])
                            ? "No. Handphone harus diisi"
                            : /(dokter|poliklinik|waktu|kategori)/gi.test(
                                form["validation-desc"]
                              )
                            ? "Kolom harus diisi"
                            : form["rawLabel"].charAt(0).toUpperCase() +
                              form["rawLabel"].substr(1) +
                              " harus diisi"
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </template>
                </b-col>
              </b-row>
            </div>
            <div class="mt-4 __antrean_blue" @click="clickOpsi('info_lainnya')">
              <font-awesome-icon
                icon="caret-down"
                v-if="!click['info_lainnya']"
              />
              <font-awesome-icon icon="caret-up" v-else />
              <strong class="ml-1">
                INFORMASI LAINNYA (Tanda-tanda vital, anamnesa, alergi)
                <span>(Optional)</span>
              </strong>
            </div>
            <b-row class="px-4 pt-4 pb-0" v-if="click['info_lainnya']">
              <template v-for="form in formBasicData">
                <b-col
                  :sm="form.col"
                  :lg="form.colLg"
                  :key="'ket_alergi_obat'+form.tmpId"
                  :class="form.class"
                  v-if="form.rawLabel == 'ket riwayat alergi obat' && checkLain('obat')"
                >
                  <b-form-group
                    :invalid-feedback="'Kolom harus diisi'"
                    style="position: relative"
                    :state="renderError({ error: form.error })"
                  >
                    <br />
                    <b-form-input
                      class="mb-2 mt-2"
                      :ref="form.label"
                      type="text"
                      v-model.lazy="formData[form.label]"
                      @keyup="
                        setValue({
                          rawLabel: form.rawLabel,
                          label: form.label,
                          $event,
                          tmpId: form.tmpId
                        })
                      "
                    />
                  </b-form-group>
                </b-col>
                
                <b-col
                  :sm="form.col"
                  :lg="form.colLg"
                  :key="'ket_alergi_makanan'+form.tmpId"
                  :class="form.class"
                  v-if="form.rawLabel == 'ket riwayat alergi makanan' && checkLain('makanan')"
                >
                  <b-form-group
                    :invalid-feedback="'Kolom harus diisi'"
                    style="position: relative"
                    :state="renderError({ error: form.error })"
                  >
                    <br />
                    <b-form-input
                      class="mb-2 mt-2"
                      :ref="form.label"
                      type="text"
                      v-model.lazy="formData[form.label]"
                      @keyup="
                        setValue({
                          rawLabel: form.rawLabel,
                          label: form.label,
                          $event,
                          tmpId: form.tmpId
                        })
                      "
                    />
                  </b-form-group>
                </b-col>

                <b-col
                  :sm="form.col"
                  :lg="form.colLg"
                  :key="'riwayat_text'+form.tmpId"
                  :class="form.class"
                  v-if="form.type == 'riwayat_text'"
                >
                  <b-form-group
                    class="text-capitalize"
                    :invalid-feedback="'Kolom harus diisi'"
                    style="position: relative"
                    :state="renderError({ error: form.error })"
                  >
                    <strong style="font-size : 13px; color: grey;">
                      {{ setLabel(form.rawLabel) }}
                    </strong>
                    <br />

                    <template v-if="checkFormAlergiPcare(form.rawLabel)">
                      <vue-select
                        :class="{ error: form.error }"
                        :options="optAlergi[form.label]"
                        v-model="formData[form.label]"
                        class="__antrean-select mt-2"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                      >
                      </vue-select>
                    </template>

                    <template v-else>
                      <b-input-group>
                        <b-form-input
                          class="mb-2 mt-2"
                          :ref="form.label"
                          type="text"
                          v-model.lazy="formData[form.label]"
                          @keyup="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                        />
                      </b-input-group>
                    </template>
                  </b-form-group>
                </b-col>

                <b-col
                  :sm="form.tmpId >= 12 ? form.col : 0"
                  :lg="form.tmpId >= 12 ? form.colLg : 0"
                  :key="form.tmpId"
                  :class="form.class"
                  :style="form.tmpId >= 12 ? '' : 'display : none;'"
                  v-else-if="
                    ![
                      'select_penyakit',
                      'pemeriksaan_fisik',
                      'pemeriksaan_lainnya',
                      'riwayat_text',
                      'ket_riwayat_text',
                    ].includes(form.type)
                  "
                >
                  <b-form-group
                    class="text-capitalize"
                    :invalid-feedback="
                      renderInvalidFeedback({
                        validationDesc: form['validation-desc']
                      })
                    "
                    style="position: relative"
                    :state="renderError({ error: form.error })"
                  >
                    <strong
                      :style="
                        [
                          'keluhan',
                          'anamnesis',
                          'alergi & kondisi khusus',
                          'keterangan lain'
                        ].includes(form.rawLabel)
                          ? 'font-size : 15px; color: grey;'
                          : 'font-size : 13px; color: grey;'
                      "
                    >
                      {{ setLabel(form.rawLabel) }}
                    </strong>
                    <br />
                    <template v-if="form.type === 'text' || form.type == 'riwayat_text'">
                      <b-input-group>
                        <template #append v-if="form.satuan">
                          <b-input-group-text class="custom_append">{{
                            form.satuan
                          }}</b-input-group-text>
                        </template>
                        <b-form-input
                          class="mb-2 mt-2"
                          :ref="form.label"
                          type="text"
                          v-model.lazy="formData[form.label]"
                          @keyup="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          @keypress="
                            form.type == 'riwayat_text'
                            ? () => {}
                            : onKeyInputNumber({
                                label: form.label,
                                rawLabel: form.rawLabel,
                                $event
                              })
                          "
                          @input="checkTanda(formData[form.label], form.label)"
                          :class="{'border-red': checkTanda(formData[form.label], form.label)}"
                        />
                      </b-input-group>
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: checkTanda(formData[form.label], form.label) })"
                        v-if="checkTanda(formData[form.label], form.label)"
                      >
                        {{ form.label == 'sistole' && sistole.message || '' }}
                        {{ form.label == 'diastole' && diastole.message || '' }}
                        {{ form.label == 'nadi' && nadi.message || '' }}
                        {{ form.label == 'respirasi' && respirasi.message || '' }}
                      </b-form-invalid-feedback>
                    </template>

                    <template v-if="form.type === 'textspecial'">
                      <b-input-group>
                        <template #append v-if="form.satuan">
                          <b-input-group-text class="custom_append">{{
                            form.satuan
                          }}</b-input-group-text>
                        </template>
                        <b-form-input
                          :disabled="form.label == 'IMT'"
                          type="text"
                          v-model.lazy="formData[form.label]"
                          @keyup="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          @keydown.native="
                            onKeyInputNumberSpecial({
                              label: form.label,
                              rawLabel: form.rawLabel,
                              $event
                            })
                          "
                          @input="checkTanda(formData[form.label], form.label)"
                          class="mb-2 mt-2"
                          :class="{'border-red': checkTanda(formData[form.label], form.label)}"
                        />
                      </b-input-group>
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: checkTanda(formData[form.label], form.label) })"
                        v-if="checkTanda(formData[form.label], form.label)"
                      >
                        {{ form.label == 'tinggi_badan' && tinggi_badan.message || '' }}
                        {{ form.label == 'berat_badan' && berat_badan.message || '' }}
                      </b-form-invalid-feedback>
                    </template>

                    <template v-if="form.type == 'textarea'">
                      <b-form-textarea
                        id="textarea"
                        v-model="formData[form.label]"
                        @keyup="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        :placeholder="form.placeholder"
                        :size="form.size"
                        :maxlength="form.maxLength"
                        class="mt-2"
                        :class="{'border-red': checkKeluhan(formData[form.label], form.label)}"
                        @input="checkKeluhan(formData[form.label], form.label)"
                      >
                      </b-form-textarea>
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: checkKeluhan(formData[form.label], form.label) })"
                        v-if="checkKeluhan(formData[form.label], form.label)"
                      >
                        {{ form.label == 'keluhan' && keluhan.message || '' }}
                        {{ form.label == 'anamnesis' && anamnesis.message || '' }}
                      </b-form-invalid-feedback>
                    </template>

                    <template v-if="form.type == 'select'">
                      <!-- Golongan Darah -->
                      <vue-select
                        :options="option_blood"
                        :placeholder="form.placeholder"
                        v-model="selectedBlood"
                        class="__antrean-select mt-2"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        v-if="form.label == 'golongan_darah'"
                      >
                      </vue-select>
                    </template>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
            <div
              class="mt-4 __antrean_blue"
              @click="clickOpsi(['riwayat_penyakit'])"
              v-if="isPoliGigi"
            >
              <font-awesome-icon
                icon="caret-down"
                v-if="!click['riwayat_penyakit']"
              />
              <font-awesome-icon icon="caret-up" v-else />
              <strong class="ml-1">Riwayat Kesehatan</strong>
            </div>
            <b-row
              class="row px-4 pt-4 pb-0"
              v-if="click['riwayat_penyakit'] && isPoliGigi"
            >
              <template v-for="form in formBasicData">
                <b-col
                  :sm="form.tmpId >= 12 ? form.col : 0"
                  :lg="form.tmpId >= 12 ? form.colLg : 0"
                  :key="form.tmpId"
                  :class="form.class"
                  :style="form.tmpId >= 12 ? '' : 'display : none;'"
                  v-if="form.type == 'select_penyakit'"
                >
                  <b-form-group class="text-capitalize">
                    <template v-if="form.rawLabel == 'ket_penyakit_lainnya'">
                      <br />
                      <b-form-input
                        :ref="form.label"
                        type="text"
                        v-model.lazy="formData[form.label]"
                        @keyup="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        :disabled="
                          !formData['penyakit_lainnya'] ||
                            (formData['penyakit_lainnya'] &&
                              formData['penyakit_lainnya'].value != 'Y')
                        "
                      />
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: form.error })"
                      >
                        Kolom harus diisi
                      </b-form-invalid-feedback>
                    </template>
                    <template v-else>
                      <strong style="font-size : 13px; color: grey;">{{
                        setLabel(form.rawLabel)
                      }}</strong>
                      <br />
                      <vue-select
                        :class="{ error: form.error }"
                        :options="option_penyakit"
                        :placeholder="form.placeholder"
                        v-model="formData[form.label]"
                        class="__antrean-select"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                      >
                      </vue-select>
                    </template>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
            <div class="mt-4 __antrean_blue" @click="clickOpsi('pemeriksaan_fisik')">
              <font-awesome-icon icon="caret-down" v-if="!click['pemeriksaan_fisik']" />
              <font-awesome-icon icon="caret-up" v-else />
              <strong class="ml-1">
                Pemeriksaan Fisik
              </strong>
            </div>
            <b-row class="row px-4 pt-4 pb-0" v-if="click['pemeriksaan_fisik']">
              <template v-for="form in formBasicData">
                <b-col
                  :sm="form.tmpId >= 12 ? form.col : 0"
                  :lg="form.tmpId >= 12 ? form.colLg : 0"
                  :key="form.tmpId"
                  :class="form.class"
                  :style="form.tmpId >= 12 ? '' : 'display : none;'"
                  v-if="form.type == 'pemeriksaan_fisik'"
                >
                  <b-form-group class="text-capitalize">
                    <template v-if="form.rawLabel == 'luas fisik'">
                      <strong style="font-size : 13px; color: grey;">{{
                        setLabel(form.rawLabel)
                      }}</strong>
                      <br />
                      <b-input-group>
                        <template #append v-if="form.satuan">
                          <b-input-group-text
                            class="custom_append"
                            style="text-transform: lowercase;"
                            >{{ form.satuan }}</b-input-group-text
                          >
                        </template>
                        <b-form-input
                          type="text"
                          v-model.lazy="formData[form.label]"
                          @keyup="
                            setValue({
                              rawLabel: form.rawLabel,
                              label: form.label,
                              $event,
                              tmpId: form.tmpId
                            })
                          "
                          @keypress="
                            onKeyInputNumber({
                              label: form.label,
                              rawLabel: form.rawLabel,
                              $event
                            })
                          "
                          class="mb-2 mt-2"
                        />
                      </b-input-group>
                    </template>
                    <template v-else-if="form.rawLabel.includes('ket')">
                      <br />
                      <b-form-input
                        :ref="form.label"
                        type="text"
                        v-model.lazy="formData[form.label]"
                        class="mt-2"
                        @keyup="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        :disabled="
                          !formData[form.label.replace('ket_', '')] ||
                            (formData[form.label.replace('ket_', '')] &&
                              formData[form.label.replace('ket_', '')].value !=
                                'Y')
                        "
                      />
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: form.error })"
                      >
                        Kolom harus diisi
                      </b-form-invalid-feedback>
                    </template>
                    <template v-else>
                      <strong style="font-size : 13px; color: grey;">{{
                        setLabel(form.rawLabel)
                      }}</strong>
                      <br />
                      <vue-select
                        :class="{ error: form.error }"
                        :options="option_pemeriksaan_fisik"
                        :placeholder="form.placeholder"
                        v-model="formData[form.label]"
                        class="__antrean-select mt-2"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                      >
                      </vue-select>
                    </template>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
            <div class="mt-4 __antrean_blue" @click="clickOpsi('pemeriksaan_lainnya')">
              <font-awesome-icon icon="caret-down" v-if="!click['pemeriksaan_lainnya']" />
              <font-awesome-icon icon="caret-up" v-else />
              <strong class="ml-1">
                Pemeriksaan Psikologis, Sosial Ekonomi, Spiritual
              </strong>
            </div>
            <b-row class="row px-4 pt-4 pb-0" v-if="click['pemeriksaan_lainnya']">
              <template v-for="form in formBasicData">
                <b-col
                  :sm="form.tmpId >= 12 ? form.col : 0"
                  :lg="form.tmpId >= 12 ? form.colLg : 0"
                  :key="form.tmpId"
                  :class="form.class"
                  :style="form.tmpId >= 12 ? '' : 'display : none;'"
                  v-if="form.type == 'pemeriksaan_lainnya'"
                >
                  <b-form-group class="text-capitalize">
                    <template v-if="form.label == 'status_psikologis'">
                      <strong style="font-size : 13px; color: grey;">{{
                        setLabel(form.rawLabel)
                      }}</strong>
                      <vue-select
                        :class="{ error: form.error }"
                        :options="option_pemeriksaan_lainnya"
                        :placeholder="form.placeholder"
                        v-model="formData[form.label]"
                        class="__antrean-select mt-2"
                        @input="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                      >
                      </vue-select>
                    </template>
                    <template
                      v-else-if="form.rawLabel == 'ket_status_psikologis'"
                    >
                      <br />
                      <b-form-input
                        :ref="form.label"
                        type="text"
                        v-model.lazy="formData[form.label]"
                        class="mt-2"
                        @keyup="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                        :disabled="
                          !formData['status_psikologis'] ||
                            (formData['status_psikologis'] &&
                              formData['status_psikologis'].value != 'L')
                        "
                      />
                      <b-form-invalid-feedback
                        style="text-transform: none"
                        :state="renderError({ error: form.error })"
                      >
                        Kolom harus diisi
                      </b-form-invalid-feedback>
                    </template>
                    <template v-else>
                      <strong style="font-size : 13px; color: grey;">{{
                        setLabel(form.rawLabel)
                      }}</strong>
                      <br />
                      <b-form-input
                        class="mb-2 mt-2"
                        :ref="form.label"
                        type="text"
                        v-model.lazy="formData[form.label]"
                        @keyup="
                          setValue({
                            rawLabel: form.rawLabel,
                            label: form.label,
                            $event,
                            tmpId: form.tmpId
                          })
                        "
                      />
                    </template>
                  </b-form-group>
                </b-col>
              </template>
            </b-row>
            <b-button
              type="submit"
              variant="primary"
              class="text-capitalize my-2 float-right mt-4"
              >selesai</b-button
            >
            <b-button
              :to="{ name: 'antrean-klinik-list' }"
              variant="danger"
              class="text-capitalize my-2 mr-4 mt-4 float-right"
              >tutup</b-button
            >
            <vue-internet-checker @status="statusInet" />
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "lodash/startCase";
import find from "lodash/find";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import "vue-datetime/dist/vue-datetime.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCamera,
  faCaretDown,
  faCaretUp,
  faCalendar
} from "@fortawesome/free-solid-svg-icons";
library.add(faCamera, faCaretDown, faCaretUp, faCalendar);

import moment from "moment";
import { mapGetters } from "vuex";
moment.locale("id");
import debounce from "lodash/debounce";
import vueInternetChecker from "vue-internet-checker";

const tmp = [
  {
    label: "nama pasien",
    type: "select",
    isImportant: "*",
    col: 12,
    colLg: 3,
    class: "",
    validations: {
      required
    }
  },
  {
    label: "no. rekam medis",
    type: "text",
    col: 6,
    colLg: 3,
    class: "",
    validations: {
      required,
      minLength: minLength(6)
    }
  },
  {
    label: "nomor handphone",
    type: "text",
    col: 6,
    colLg: 3,
    class: "",
    validations: {
      required,
      maxLength: maxLength(20)
    }
  },
  {
    label: "usia pasien",
    type: "text",
    col: 6,
    colLg: 3,
    class: "",
    validations: {
      required
    }
  },
  {
    label: "jenis kelamin",
    type: "select",
    col: 6,
    colLg: 3,
    class: "mb-3",
    isImportant: "*",
    placeholder: "Pilih Jenis Kelamin",
    validations: {
      required
    }
  },
  {
    label: "poliklinik",
    type: "select",
    isImportant: "*",
    col: 12,
    placeholder: "Pilih Poliklinik",
    colLg: 3,
    class: "mb-3",
    validations: {
      required
    }
  },
  {
    label: "nama dokter",
    type: "select",
    isImportant: "*",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih Nama Dokter",
    validations: {
      required
    }
  },
  {
    label: "slot waktu",
    type: "select",
    isImportant: "*",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih Slot Waktu",
    validations: {
      required
    }
  },
  {
    label: "provinsi",
    type: "select",
    col: 12,
    placeholder: "Pilih Provinsi",
    colLg: 3,
    class: "mb-3",
    validations: {}
  },
  {
    label: "kota",
    type: "select",
    col: 12,
    placeholder: "Pilih Kabupaten / Kota",
    colLg: 3,
    class: "mb-3",
    validations: {}
  },
  {
    label: "alamat rumah",
    type: "textarea",
    col: 12,
    placeholder: "Alamat",
    colLg: 6,
    class: "mb-3",
    validations: {}
  },
  {
    label: "",
    type: "hidden",
    col: 12,
    class: "",
    validations: {}
  },
  {
    label: "suhu",
    type: "textspecial",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "C",
    validations: {}
  },
  {
    label: "sistole",
    type: "text",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "mmHG",
    validations: {}
  },
  {
    label: "diastole",
    type: "text",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "mmHG",
    validations: {}
  },
  {
    label: "nadi",
    type: "text",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "x/menit",
    validations: {}
  },
  {
    label: "respirasi",
    type: "text",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "x/menit",
    validations: {}
  },
  {
    label: "saturasi oksigen",
    type: "text",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "%",
    validations: {}
  },
  {
    label: "tinggi badan",
    type: "textspecial",
    col: 4,
    colLg: 2,
    class: "mt-6",
    maxlength: 4,
    satuan: "cm",
    validations: {}
  },
  {
    label: "berat badan",
    type: "textspecial",
    col: 4,
    colLg: 2,
    class: "mt-6",
    maxlength: 4,
    satuan: "kg",
    validations: {}
  },
  {
    label: "lingkar perut",
    type: "textspecial",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "cm",
    validations: {}
  },
  {
    label: "IMT",
    type: "textspecial",
    col: 4,
    colLg: 2,
    class: "mt-6",
    satuan: "kg/m2",
    validations: {}
  },
  {
    label: "golongan darah",
    type: "select",
    col: 4,
    placeholder: "Pilih Gol. Darah",
    colLg: 2,
    class: "mb-3",
    validations: {}
  },
  {
    label: "keluhan",
    type: "textarea",
    col: 6,
    placeholder:
      "Tuliskan keluhan utama secara singkat, contoh: Sakit kepala, demam",
    colLg: 6,
    class: "",
    size: "lg",
    rows: 3,
    validations: {}
  },
  {
    label: "anamnesis",
    type: "textarea",
    col: 6,
    placeholder:
      "Tuliskan detail keluhan, contoh: demam 3 hari",
    colLg: 6,
    class: "",
    size: "lg",
    rows: 3,
    validations: {}
  },
  {
    label: "alergi & kondisi khusus",
    type: "hidden",
    col: 12,
    class: "mt-3",
    validations: {}
  },
  {
    label: "riwayat penyakit",
    type: "riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "riwayat alergi obat",
    type: "riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "ket riwayat alergi obat",
    type: "ket_riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "riwayat alergi makanan",
    type: "riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "ket riwayat alergi makanan",
    type: "ket_riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "riwayat alergi udara",
    type: "riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "riwayat alergi lain",
    type: "riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "riwayat pengobatan",
    type: "riwayat_text",
    col: 4,
    colLg: 3,
    class: "mt-6",
    satuan: null,
    validations: {}
  },
  {
    label: "keterangan lain",
    type: "riwayat_text",
    // placeholder: "",
    col: 6,
    // rows: 2,
    colLg: 6,
    validations: {}
  },
  {
    label: "penyakit jantung",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "diabetes",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "haemopilia",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "hepatitis",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "gastring",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "penyakit lainnya",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_penyakit_lainnya",
    type: "select_penyakit",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "luas fisik",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 6,
    class: "mt-6",
    satuan: "m2",
    validations: {}
  },
  {
    label: "kepala",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_kepala",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "mata",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_mata",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "telinga",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_telinga",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "hidung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_hidung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "rambut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_rambut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "bibir",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_bibir",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "gigi geligi",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_gigi_geligi",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "lidah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_lidah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "langit langit",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_langit_langit",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "leher",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_leher",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "tenggorokan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tenggorokan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "tonsil",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tonsil",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "dada",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_dada",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "payudara",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_payudara",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "punggung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_punggung",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "perut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_perut",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "genital",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_genital",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "anus",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_anus",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "lengan atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_lengan_atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "lengan bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_lengan_bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "jari tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_jari_tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "kuku tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_kuku_tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "persendian tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_persendian_tangan",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "tungkai atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tungkai_atas",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "tungkai bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_tungkai_bawah",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "jari kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_jari_kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "kuku kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_kuku_kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "persendian kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_persendian_kaki",
    type: "pemeriksaan_fisik",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "status psikologis",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "Pilih",
    validations: {}
  },
  {
    label: "ket_status_psikologis",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "sosial ekonomi",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  },
  {
    label: "spiritual",
    type: "pemeriksaan_lainnya",
    col: 12,
    colLg: 3,
    class: "mb-3",
    placeholder: "",
    validations: {}
  }
];

export default {
  components: {
    DatePickerX: () => import("v-calendar/lib/components/date-picker.umd"),
    "vue-select": () => import("vue-select"),
    vueInternetChecker
  },
  data: () => ({
    // Edit Form
    antrean_id: null,
    editData: {},
    selectedPoliMount: {},
    selectedDokterMount: {},
    selectedSlotMount: {},
    selectedKategoriMount: {},
    selectedProvinsiMount: {},
    selectedKotaMount: {},
    selectedBloodMount: {},
    selectedGenderMount: {},

    click: {
      info_lainnya: false,
      riwayat_penyakit: false,
      pemeriksaan_fisik: false,
      pemeriksaan_lainnya: false
    },
    validateTanggal: false,
    dataTanggal: null,
    selectedPasien: null,
    selectedPoli: null,
    selectedKategori: null,
    selectedDokter: null,
    selectedSlot: null,
    selectedProvinsi: null,
    selectedKota: null,
    selectedBlood: null,
    selectedGender: null,
    formBasicData: null,
    formData: null,

    options: {
      dokter: [],
      nama_pasien: []
    },
    pasiens: [],
    beingSubmit: false,
    checkPaketData: null,
    option_poliklinik: [],
    option_nama_dokter: [],
    option_slot_waktu: [],
    option_kategori: [],
    option_provinsi: [],
    option_kota: [],
    option_blood: [
      { label: "A", value: "A" },
      { label: "AB", value: "AB" },
      { label: "B", value: "B" },
      { label: "O", value: "O" },
      { label: "Tidak Diketahui", value: "Tidak Diketahui" }
    ],
    option_gender: [
      { label: "Laki-laki", value: 1 },
      { label: "Perempuan", value: 0 },
      { label: "Tidak diketahui", value: 2 },
      { label: "Tidak dapat ditentukan", value: 3 },
      { label: "Tidak mengisi", value: 4 }
    ],

    isCustomSlot: false,
    customSlot: {},
    isOnline: true,
    card_number: {
      number: null,
      error: false,
      message: null
    },
    dataBPJS: null,
    activeBPJS: true,
    isErrorKategori: false,
    validateKategori: false,
    dataBPJSSuccess: false,
    nokaBpjs: null, //buat edit bpjs yang dari jkn
    fromJkn: false,
    option_penyakit: [
      { label: "Tidak Ada", value: "T" },
      { label: "Ada", value: "Y" }
    ],
    option_pemeriksaan_fisik: [
      { label: "Tidak Diperiksa", value: "N" },
      { label: "Tidak Ada Kelainan", value: "T" },
      { label: "Ada Kelainan", value: "Y" }
    ],
    option_pemeriksaan_lainnya: [
      { label: "Tidak Ada Kelainan", value: "N" },
      { label: "Cemas", value: "C" },
      { label: "Takut", value: "T" },
      { label: "Marah", value: "M" },
      { label: "Sedih", value: "S" },
      { label: "Lain-Lain", value: "L" }
    ],
    selectedType: {
      select_penyakit: 'Y',
      pemeriksaan_fisik: 'Y',
      pemeriksaan_lainnya: 'L'
    },
    isPoliGigi: false,
    kodepoliWsBpjs: [],
    
    optAlergi: {
      riwayat_alergi_makanan: [],
      riwayat_alergi_udara: [],
      riwayat_alergi_obat: [],
    },
    pcareVersion: null,
    alergi: {
      riwayat_alergi_makanan: null,
      ket_riwayat_alergi_makanan: null,
      riwayat_alergi_udara: null,
      ket_riwayat_alergi_obat: null,
      riwayat_alergi_obat: null,
      alergi_udara_bpjs: null,
      riwayat_alergi_obat: null,
      alergi_obat_bpjs: null,
    },
    typeAlergi: {
      riwayat_alergi_makanan: 'alergi_makanan_bpjs',
      riwayat_alergi_obat: 'alergi_obat_bpjs',
      riwayat_alergi_udara: 'alergi_udara_bpjs'
    },
    keluhan: {
      error: false,
      message: null,
    },
    anamnesis: {
      error: false,
      message: null,
    },
    tinggi_badan: {
      error: false,
      message: null,
    },
    berat_badan: {
      error: false,
      message: null,
    },
    sistole: {
      error: false,
      message: null,
    },
    diastole: {
      error: false,
      message: null,
    },
    nadi: {
      error: false,
      message: null,
    },
    respirasi: {
      error: false,
      message: null,
    },
    disableDate: false
  }),
  watch: {
    dataTanggal: function(newVal, oldVal) {
      this.validateTanggal = false;
      if (oldVal != newVal) {
        this.$nextTick(() => {
          this.formData.poliklinik = "";
          this.formData.slot_waktu = "";
          this.formData.nama_dokter = "";
          this.selectedPoli = null;
          this.selectedDokter = null;
          this.selectedSlot = null;
        });
      }

      this.getRefPoliWsBPJS().then(() => {
        this.getPoliklinik().then(() => {
          this.selectedPoliMount = {};
        });
      });
    },
    selectedKategori: async function(newVal, oldVal) {
      if (oldVal != newVal && oldVal) {
        this.$nextTick(() => {
          this.dataTanggal = null;
        });
      }
      if (this.selectedKategori && this.selectedKategori.value != 2) {
        this.disableDate = false;
        this.isErrorKategori = false;
        this.activeBPJS = true;
        this.card_number = {
          number: null,
          error: false,
          message: null
        };
        this.pcareVersion = null;
      } else {
        this.activeBPJS = false;
      }
      this.dataBPJSSuccess = false;

      if (this.selectedKategori) {
        this.validateKategori = false;
        let is_bpjs = this.selectedKategori.value == 2;
        
        if (this.bpjsAuthValid && this.bpjsConfig.pcare_version == '1' && is_bpjs) {
          this.pcareVersion = this.bpjsConfig.pcare_version;
          if (this.optAlergi.riwayat_alergi_makanan.length < 1) this.optAlergi.riwayat_alergi_makanan = await this.fetchAlergiJenis('01');
          if (this.optAlergi.riwayat_alergi_udara.length < 1) this.optAlergi.riwayat_alergi_udara = await this.fetchAlergiJenis('02');
          if (this.optAlergi.riwayat_alergi_obat.length < 1) this.optAlergi.riwayat_alergi_obat = await this.fetchAlergiJenis('03');
        }

        if (this.option_nama_dokter.length > 0) {
          this.option_nama_dokter = this.option_nama_dokter.map(item => {
            let disable = item.origin_disabled;
            if (is_bpjs) {
              if (!item.bpjs_kode_dokter) {
                disable = true;
              } else {
                disable = false;
              }
            }

            return {
              ...item,
              disable: disable
            };
          });
        }
      }

      this.checkKeluhan(this.formData.keluhan, 'keluhan');
      this.setValueAlergi('riwayat_alergi_makanan');
      this.setValueAlergi('riwayat_alergi_udara');
      this.setValueAlergi('riwayat_alergi_obat');
    },
    isErrorKategori() {
      if (this.isErrorKategori) {
        this.dataTanggal = null;
      }
    },
    selectedProvinsi: function(newVal, oldVal) {
      if (newVal == null || newVal == undefined || newVal == "") {
        this.selectedKota = null;
        this.option_kota = [];
      }
    }
  },
  computed: {
    ...mapGetters([
      "getKlinikId",
      "satusehatAuthValid",
      "getRolesName",
      "getBridgingAntreanFktp",
      "bpjsAuthValid",
      "bpjsConfig",
    ]),
    maxDate() {
      // return new Date()
      return moment()
        .add(2, "months")
        .toDate();
    },
    minDate() {
      // return new Date()
      return moment()
        .toDate();
    },
    isTambah() {
      return this.antrean_id ? false : true;
    },
    isEdit() {
      return !this.isTambah;
    },
    isPerawat() {
      /**
       * Ini adalah function yang mengecek apakah sebuah role boleh edit atau tidak
       * Kenapa namanya isPerawat, karena awalnya ini untuk mengecek apakah perawat atau bukan. Jika perawat, maka tidak boleh edit beberapa part. 
       * Tapi karena sudah works, dont rename it!
       */

      let rolesCanEdit = ['pic_cabang', 'frontdesk', 'kasir'];
      const roles = rolesCanEdit.filter(feature => {
        return this.getRolesName.includes(feature);
      });

      if(roles.length > 0) {
        return false
      } else {
        return this.getRolesName.includes("perawat");
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (
      !this.beingSubmit &&
      localStorage.getItem("IDLE") != 1 &&
      to.name != "klinik-subskripsi" &&
      to.name != "login-page" &&
      to.name != "home"
    ) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  validations() {
    return {
      formData: {
        ...tmp.reduce((obj, item) => {
          obj[item.label.split(" ").join("_")] = item.validations;
          return obj;
        }, {})
      }
    };
  },
  async mounted() {
    if (this.$route.name == 'antrean-klinik-tambah'){
      this.resetState()
    }

    this.antrean_id = this.$router.currentRoute.params.id || "";

    await this.cekPaket();
    this.getProvinsi();
    this.formBasicData = this.setFormBasicData();
    this.formData = this.setFormData();

    this.getKategori().then(() => {
      this.selectedKategoriMount = {};
    });

    let tb_bb = {
      tinggi_badan: 0,
      berat_badan: 0
    };
    if (this.isEdit) {
      let data = await this.fetchAntrean(this.antrean_id);

      let {
        pasien,
        waktu_konsultasi,
        poli,
        dokter,
        slot_consultation,
        kategori_pasien,
        is_custom_slot,
        nama
      } = data;

      if (kategori_pasien && kategori_pasien.nama) {
        let selectedKategori = {
          label: kategori_pasien.nama,
          value: kategori_pasien.id
        };
        this.selectedKategori = this.selectedKategoriMount = selectedKategori;
      }
      
      if (this.bpjsAuthValid && this.bpjsConfig.pcare_version == '1' && kategori_pasien.id == 2) this.pcareVersion = this.bpjsConfig.pcare_version;

      if (data.sumber == 1) this.fromJkn = true;
      if (this.fromJkn && !data.jkn_is_edited) slot_consultation = "";

      this.isCustomSlot = is_custom_slot;
      this.customSlot = slot_consultation;

      let localMonth = moment.months(),
        dateDt = waktu_konsultasi.split(",")[1].substring(1),
        dateSplit = dateDt.split(" "),
        monthDt = dateSplit[1],
        monthNumDt = localMonth.indexOf(monthDt) + 1;

      this.dataTanggal = moment(
        `${monthNumDt} ${dateSplit[0]} ${dateSplit[2]}`
      ).toDate();
      this.formData.waktu_konsultasi = moment(this.dataTanggal).format(
        "YYYY-MM-DD"
      );

      let eventVal = {
        label: nama,
        value: pasien.id,
        diable: true
      };
      this.options.nama_pasien = [eventVal];

      this.selectedPasien = eventVal;

      if (poli && poli.nama) {
        let selectedPoli = {
          label: poli.nama,
          value: poli.id
        };
        this.selectedPoli = this.selectedPoliMount = selectedPoli;

        this.setValue({
          rawLabel: "poliklinik",
          label: "poliklinik",
          $event: selectedPoli
        });
      }

      if (dokter && dokter.nama) {
        let selectedDokter = {
          label: dokter.nama,
          value: dokter.id
        };

        this.selectedDokter = this.selectedDokterMount = selectedDokter;
        if (dokter.nama) {
          this.setValue({
            rawLabel: "nama dokter",
            label: "nama_dokter",
            $event: selectedDokter
          });
        }
      }

      if (slot_consultation && slot_consultation.value) {
        let selectedSlot = {
          label: slot_consultation.label,
          value: slot_consultation.value,
          no_urut: slot_consultation.no_urut
        };

        this.selectedSlot = this.selectedSlotMount = selectedSlot;
        if (slot_consultation.value) {
          this.setValue({
            rawLabel: "slot waktu",
            label: "slot_waktu",
            $event: selectedSlot
          });
        }
      }

      this.card_number.number = data.bpjs_noka;
      this.nokaBpjs = data.bpjs_noka;
      if (data.hasOwnProperty("anamnesa")) {
        this.setValue({
          rawLabel: "keluhan",
          label: "keluhan",
          $event: data.anamnesa.keluhan
        });
        this.setValue({
          rawLabel: "anamnesis",
          label: "anamnesis",
          $event: data.anamnesa.notes
        });
      }

      if (pasien) {
        tb_bb = {
          tinggi_badan: pasien.tinggi_badan,
          berat_badan: pasien.berat_badan
        };

        this.searchPasien("", pasien.id);
        this.autoFill(pasien, "nama_pasien");
        this.formData["nama_pasien"] = eventVal;
        this.formData["usia_pasien"] =
          (pasien["age_year"] || 0) +
          " tahun " +
          (pasien["age_month"] || 0) +
          " bulan " +
          (pasien["age_day"] || 0) +
          " hari";
        const prop = [
          "suhu",
          "sistole",
          "diastole",
          "nadi",
          "respirasi",
          "lingkar_perut",
          "saturasi_oksigen"
        ];
        for (let i in prop) {
          let x = prop[i];
          if (pasien.hasOwnProperty(x) && pasien[x]) {
            this.formData[x] = pasien[x];
            this.setValue({
              label: x,
              rawLabel: x.replace("_", " "),
              $event: pasien[x]
            });
          }
        }
      }

      this.formBasicData = this.setFormBasicData();
      this.formData["slot_waktu"] = this.selectedSlot;

      if (data.hasOwnProperty("pemeriksaan_fisik"))
        this.setPemeriksaanFisik(data.pemeriksaan_fisik);
      if (data.hasOwnProperty("diagnosa"))
        this.setRiwayatPenyakit(data.diagnosa);
      this.editData = this.setDataValue(this.formData);
    }
    // end edit

    if (this.$router.currentRoute.query.isAddAntrean) {
      const setPasien = await this.$axios.get(
        `pasien?klinik_id=${this.getKlinikId}&limit=1`
      );
      let pasien = setPasien.data.data.data["0"];

      let eventVal = {
        label: pasien.nama,
        value: pasien.id,
        disable: true
      };

      tb_bb = {
        tinggi_badan: pasien.tinggi_badan,
        berat_badan: pasien.berat_badan
      };

      this.options.nama_pasien = [eventVal];
      this.selectedPasien = eventVal;
      this.searchPasien("", pasien.id);
      this.autoFill(pasien, "nama_pasien");
      this.formData["nama_pasien"] = eventVal;
    }

    // calculate imt
    if (parseInt(tb_bb.tinggi_badan) && parseInt(tb_bb.berat_badan)) {
      let tinggi_badan = parseInt(tb_bb.tinggi_badan) * 0.01;
      let imt = parseInt(tb_bb.berat_badan) / (tinggi_badan * tinggi_badan);
      this.formData["IMT"] = imt.toFixed(2);
    } else {
      this.formData["IMT"] = null;
    }
  },
  methods: {
    resetState() {
      this.antrean_id = null
      this.editData = {}
      this.selectedPoliMount = {}
      this.selectedDokterMount = {}
      this.selectedSlotMount = {}
      this.selectedKategoriMount = {}
      this.selectedProvinsiMount = {}
      this.selectedKotaMount = {}
      this.selectedBloodMount = {}
      this.selectedGenderMount = {}

      this.click = {
        info_lainnya: false,
        riwayat_penyakit: false,
        pemeriksaan_fisik: false,
        pemeriksaan_lainnya: false
      }
      this.validateTanggal = false
      this.dataTanggal = null
      this.selectedPasien = null
      this.selectedPoli = null
      this.selectedKategori = null
      this.selectedDokter = null
      this.selectedSlot = null
      this.selectedProvinsi = null
      this.selectedKota = null
      this.selectedBlood = null
      this.selectedGender = null
      this.formBasicData = null
      this.formData = null

      this.options = {
        dokter: [],
        nama_pasien: []
      }
      this.pasiens = []
      this.beingSubmit = false,
      this.checkPaketData = null,
      this.option_poliklinik = []
      this.option_nama_dokter = []
      this.option_slot_waktu = []
      this.option_kategori = []
      this.option_provinsi = []
      this.option_kota = []
      this.option_blood = [
        { label: "A", value: "A" },
        { label: "AB", value: "AB" },
        { label: "B", value: "B" },
        { label: "O", value: "O" },
        { label: "Tidak Diketahui", value: "Tidak Diketahui" }
      ]
      this.option_gender = [
        { label: "Laki-laki", value: 1 },
        { label: "Perempuan", value: 0 },
        { label: "Tidak diketahui", value: 2 },
        { label: "Tidak dapat ditentukan", value: 3 },
        { label: "Tidak mengisi", value: 4 }
      ]

      this.isCustomSlot = false
      this.customSlot = {}
      this.isOnline = true
      this.card_number = {
        number: null,
        error: false,
        message: null
      }
      this.dataBPJS = null
      this.activeBPJS = true
      this.isErrorKategori = false
      this.validateKategori = false
      this.dataBPJSSuccess = false
      this.nokaBpjs = null //buat edit bpjs yang dari jkn
      this.fromJkn = false
      this.option_penyakit = [
        { label: "Tidak Ada", value: "T" },
        { label: "Ada", value: "Y" }
      ]
      this.option_pemeriksaan_fisik = [
        { label: "Tidak Diperiksa", value: "N" },
        { label: "Tidak Ada Kelainan", value: "T" },
        { label: "Ada Kelainan", value: "Y" }
      ]
      this.option_pemeriksaan_lainnya = [
        { label: "Tidak Ada Kelainan", value: "N" },
        { label: "Cemas", value: "C" },
        { label: "Takut", value: "T" },
        { label: "Marah", value: "M" },
        { label: "Sedih", value: "S" },
        { label: "Lain-Lain", value: "L" }
      ]
      this.selectedType = { pemeriksaan_fisik: "Y", pemeriksaan_lainnya: "L" }
      this.isPoliGigi = false

      this.optAlergi = {
        riwayat_alergi_makanan: [],
        riwayat_alergi_udara: [],
        riwayat_alergi_obat: [],
      }
      this.pcareVersion = null
      this.alergi = {
        riwayat_alergi_makanan: null,
        ket_riwayat_alergi_makanan: null,
        riwayat_alergi_udara: null,
        ket_riwayat_alergi_obat: null,
        riwayat_alergi_obat: null,
        alergi_udara_bpjs: null,
        riwayat_alergi_obat: null,
        alergi_obat_bpjs: null,
      }
      this.keluhan = {
        error: false,
        message: null,
      }
    },
    handleMouseLeave(poper_ref) {
      if (this.$refs[poper_ref] && this.$refs[poper_ref] != undefined) this.$refs[poper_ref][0].$emit("close");
    },
    checkTextOverflow(select_ref, poper_ref) {
      const inputElement = this.$refs[select_ref];

      if (inputElement) {
        if (inputElement[0].scrollWidth > inputElement[0].clientWidth) {
          this.$refs[poper_ref][0].$emit("open");
        }
      }
    },
    async notifOffline(type) {
      let el = document.getElementsByClassName("vs__search");

      if (
        !this.isOnline &&
        type == "dokter" &&
        this.formData.nama_dokter == ""
      ) {
        el.forEach(item => {
          item.blur();
        });

        this.option_nama_dokter = [];
        this.$swal({
          title: "Oops...",
          text: "Gagal memuat data, periksa koneksi Anda kembali.",
          type: "error",
          showCancelButton: true,
          cancelButtonText: "Batal",
          confirmButtonText: "Coba Lagi"
        }).then(async res => {
          if (res.value && this.selectedPoli) {
            await this.getDokter(this.selectedPoli.value);
          }
        });
      }

      if (!this.isOnline && type == "slot" && this.formData.slot_waktu == "") {
        el.forEach(item => {
          item.blur();
        });

        this.option_slot_waktu = [];
        this.$swal({
          title: "Oops...",
          text: "Gagal memuat data, periksa koneksi Anda kembali.",
          type: "error",
          showCancelButton: true,
          cancelButtonText: "Batal",
          confirmButtonText: "Coba Lagi"
        }).then(async res => {
          if (
            res.value &&
            this.selectedDokter &&
            this.selectedPoli &&
            this.dataTanggal
          ) {
            await this.getSlot(
              this.selectedDokter.value,
              this.selectedPoli.value,
              this.dataTanggal
            );
          }
        });
      }
    },
    async statusInet(ele) {
      this.isOnline = ele;
      if (ele && this.selectedPoli && this.option_nama_dokter.length == 0) {
        await this.getDokter(this.selectedPoli.value);
      }
      if (
        ele &&
        this.selectedDokter &&
        this.selectedPoli &&
        this.dataTanggal &&
        this.option_slot_waktu.length == 0
      ) {
        await this.getSlot(
          this.selectedDokter.value,
          this.selectedPoli.value,
          this.dataTanggal
        );
      }
    },
    async fetchAntrean(id) {
      try {
        const { success, data } = (
          await this.$axios.get(
            `transaksi/${id}?klinik_id=${this.getKlinikId}`
          )
        ).data;
        return data;
      } catch (err) {}
    },
    async getDokter(id) {
      try {
        const res = await this.$axios.get(
          `transaksi/list-dokter?klinik_id=${this.getKlinikId}&limit=50&poli_id=${id}`
        );
        const { data } = res.data;

        if (this.isEdit) {
          this.selectedDokter = this.selectedDokterMount;
          this.formData.nama_dokter = this.selectedDokterMount.value;
        }
        let is_bpjs =
          this.selectedKategori && this.selectedKategori.value == 2;
        this.option_nama_dokter = data.map(item => {
          let disable = item.disable;
          if (is_bpjs) {
            if (!item.data.bpjs_kode_dokter) {
              disable = true;
            } else {
              disable = false;
            }
          }

          return {
            label: `${item.data.title}`,
            value: item.data.value,
            disable: disable,
            origin_disabled: item.disable,
            bpjs_kode_dokter: item.data.bpjs_kode_dokter || null
          };
        });
      } catch (error) {
        if (this.isOnline) {
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, terjadi gangguan sistem.",
            type: "error",
            confirmButtonText: "OK"
          });
        } else {
          this.option_nama_dokter = [];
          this.formData.nama_dokter = "";
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, periksa koneksi Anda kembali.",
            type: "error",
            showCancelButton: true,
            cancelButtonText: "Batal",
            confirmButtonText: "Coba Lagi"
          }).then(async res => {
            if (res.value) {
              await this.getDokter(id);
            }
          });
        }
      }
    },
    async getRefPoliWsBPJS(){
      if(!this.getBridgingAntreanFktp) return;
      if(!this.selectedKategori) return;
      if(this.selectedKategori.value != 2) return;
      try {
        const tanggalPeriksa = this.dataTanggal.toISOString().split('T')[0];
        const res = await this.$axios.get(
          `bpjs/wsbpjs/poli?klinik_id=${this.getKlinikId}&tanggal=${tanggalPeriksa}`
        );

        this.kodepoliWsBpjs = [];

        if(res.data.metadata.code == 200 && res.data.metadata.message == "OK"){
          this.kodepoliWsBpjs = res.data.response.map(item => item.kodepoli);
        }
      } catch (error) {
      }
    },
    async getPoliklinik() {
      if(!this.selectedKategori) return;
      try {
        const res = await this.$axios.get(
          `poliklinik?klinik_id=${this.getKlinikId}&limit=50`
        );
        const { data } = res.data.data;
        if (this.isEdit && this.selectedPoliMount && this.selectedPoliMount.value) {
          this.selectedPoli = this.selectedPoliMount;
          this.formData.poliklinik = this.selectedPoliMount.value || "";
        }
        this.option_poliklinik = data.map(item => {
          let disable = false;

          if(this.selectedKategori.value == 2 && this.getBridgingAntreanFktp){
            if(item.bpjs_kdpoli){
              if(this.kodepoliWsBpjs.includes(item.bpjs_kdpoli)){
                disable = false;
              } else {
                disable = true;
              }
            } else{
              disable = true;
            }
          }

          return {
            label: `${item.nama}`,
            value: item.id,
            disable: disable
          };
        });
      } catch (error) {
        if (this.isOnline) {
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, terjadi gangguan sistem.",
            type: "error",
            confirmButtonText: "OK"
          });
        } else {
          this.formData.poliklinik = "";
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, periksa koneksi Anda kembali.",
            type: "error",
            showCancelButton: true,
            cancelButtonText: "Batal",
            confirmButtonText: "Coba Lagi"
          }).then(async res => {
            if (res.value) {
              await this.getPoliklinik();
            }
          });
        }
      }
    },
    async getSlot(dokter_id, poli_id, tgl) {
      try {
        let date = moment(tgl).format("YYYY-MM-DD");
        const res = await this.$axios.get(
          `transaksi/antrean-slot?klinik_id=${
            this.getKlinikId
          }&limit=50&date=${date}&poli_id=${poli_id}&dokter_id=${dokter_id}&is_create=${
            this.isEdit ? 0 : 1
          }`
        );

        const { data } = res.data;
        if (this.isEdit) {
          this.selectedSlot = this.selectedSlotMount;
          this.formData.slot_waktu = this.selectedSlot.value || "";
        }
        this.option_slot_waktu = data;
      } catch (error) {
        if (this.isOnline) {
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, terjadi gangguan sistem.",
            type: "error",
            confirmButtonText: "OK"
          });
        } else {
          this.option_slot_waktu = [];
          this.formData.slot_waktu = "";
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, periksa koneksi Anda kembali.",
            type: "error",
            showCancelButton: true,
            cancelButtonText: "Batal",
            confirmButtonText: "Coba Lagi"
          }).then(async res => {
            if (res.value) {
              await this.getSlot(dokter_id, poli_id, tgl);
            }
          });
        }
      }
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(
          `kategori-pasien?klinik_id=${this.getKlinikId}`
        );
        const { data } = res.data;
        this.option_kategori = data.map(item => {
          return {
            label: `${item.nama}`,
            value: item.id
          };
        });
      } catch (error) {}
    },
    async getProvinsi() {
      try {
        const res = await this.$axios.get(
          `wilayah/provinsi?klinik_id=${this.getKlinikId}`
        );
        const { data } = res.data;
        this.option_provinsi = data.map(item => {
          return {
            label: `${item.provinsi_nama}`,
            value: item.id
          };
        });
      } catch (error) {}
    },
    async getKota(provinsi_id) {
      try {
        if (!provinsi_id || provinsi_id == "" || provinsi_id == undefined) {
          this.$swal({
            text: `Silakan pilih provinsi`,
            type: "warning"
          });
          return;
        }
        const res = await this.$axios.get(
          `wilayah/kota?klinik_id=${this.getKlinikId}&provinsi_id=${provinsi_id}`
        );
        const { data } = res.data;
        this.option_kota = data.map(item => {
          return {
            label: `${item.nama}`,
            value: item.id
          };
        });
      } catch (error) {}
    },
    clickOpsi(type) {
      if (this.click.hasOwnProperty(type)) {
        if (this.click[type] == false) {
          this.click[type] = true;
        } else {
          this.click[type] = false;
        }
      }
    },
    goToPasienBaru() {
      localStorage.setItem("is_antrean", true);
      this.beingSubmit = true;
      this.$router.push({
        name: "pasien-klinik-tambah"
      });
    },
    checkAge(dataPasien, type) {
      let val = dataPasien.tanggal_lahir;
      if (type == "detailed") {
        return (
          dataPasien["age_year"] +
          " tahun " +
          dataPasien["age_month"] +
          " bulan " +
          dataPasien["age_day"] +
          " hari"
        );
      }
      var x = moment().diff(val, "years");
      var y = moment().diff(val, "months");
      var z = moment().diff(val, "days");
      if (x == 0 && y == 0 && z != 0) {
        return moment().diff(val, "days") + " hari";
      } else if (x == 0 && y != 0) {
        return moment().diff(val, "months") + " bulan";
      } else {
        return moment().diff(val, "years") + " tahun";
      }
    },
    checkInput({ object, val } = {}) {
      if (typeof val === "Object") {
        const tmp = val.target.value;
        this.checkError[object] =
          object === "jenis_kelamin" || tmp ? null : object;
      } else {
        this.checkError[object] =
          object === "jenis_kelamin" || val ? null : object;
      }
    },
    triggerDob() {
      const x = this.$refs.dob;
      const {
        $el: { firstElementChild }
      } = x;
      firstElementChild && firstElementChild.click();
    },
    overwriteAntrean() {
      this.$swal({
        title: "Pasien telah berada pada list antrean",
        text: `Apakah Anda yakin untuk melanjutkan registrasi?`,
        type: "question",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
        }
      });
    },
    onKeyInputNumberSpecial({ label, rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (
        charCode == 37 ||
        charCode == 38 ||
        charCode == 39 ||
        charCode == 40 ||
        charCode == 8 ||
        charCode == 46 ||
        charCode == 9
      ) {
        return;
      }

      if (!evt.key.match(/[0-9,.]/)) {
        evt.preventDefault();
      }
    },
    onKeyInputNumber({ label, rawLabel, $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        void this.setValue({
          label,
          rawLabel,
          $event
        });
      }
    },
    whitelistValidation() {
      return this.setFormBasicData()
        .filter(item => item.validations && !item.validations.required)
        .map(item => item.rawLabel);
    },
    fieldErrors(formBasicData) {
      let fieldErros = [];
      let etcFieldErrors = [];
      const that = this;

      return {
        runValidation() {
          fieldErros = [];
          etcFieldErrors = [];

          formBasicData.forEach(elForm => {
            const mainLabels = {
              nama_pasien: false,
              poliklinik: that.dataTanggal == null,
              nama_dokter: that.formData.poliklinik == "",
              slot_waktu: that.formData.nama_dokter == "" || that.isCustomSlot,
              kategori: that.dataTanggal == null,
              nomor_handphone: that.formData.nama_pasien == null
            };

            if (
              elForm.error &&
              elForm.validations.hasOwnProperty("required") &&
              !that.formData[`${elForm.label}`]
            ) {
              if (mainLabels[`${elForm.label}`] == false) {
                fieldErros.push(elForm.rawLabel.toLowerCase());
                return;
              }

              if (that.dataTanggal) etcFieldErrors.push(elForm.rawLabel.toLowerCase());
            }
          });
          fieldErros = fieldErros.length > 0 ? fieldErros : etcFieldErrors;
        },
        display() {
          return fieldErros;
        }
      };
    },
    submitForm() {
      const { formBasicData } = this;
      formBasicData.map(item => {
        if (item.type != "hidden") {
          this.triggerValidation({
            label: item.label,
            $v: this.$v,
            $vm: this,
            rawLabel: item.rawLabel
          });
        }
      });

      let card_number = false;
      if (this.selectedKategori && this.selectedKategori.value == 2) {
        if (
          this.card_number.number == "" ||
          this.card_number.number == null ||
          this.card_number.number == undefined
        ) {
          card_number = true;
          this.card_number.error = true;
          this.card_number.message = "Nomor harus diisi";
        }
      }

      let fieldErrors = this.fieldErrors(formBasicData);
      fieldErrors.runValidation();
      let { v, m } = this.checkSelectedAda();

      let popupErrors = "Silakan lengkapi kolom yang harus diisi!";
      if (fieldErrors.display() || v) {
        let fieldErr = [...fieldErrors.display(), ...m];
        popupErrors = `Oops..! Ada kolom yang belum terisi!<br>Lengkapi kolom ${fieldErr.join(', ')} sebelum menyimpan data!`;
        popupErrors = popupErrors.replace(/\n/g, '<br>');
      }
      
      let alergi = [];
      // if (this.pcareVersion == '1') {
      //   if (this.checkValueData(this.formData['riwayat_alergi_obat'])) {
      //     let fBasic = this.formBasicData.find(f => f.label == 'ket_riwayat_alergi_obat');
      //     if (!this.checkValueData(this.formData['ket_riwayat_alergi_obat']) && this.checkLain('obat')) {
      //       alergi.push('keterangan riwayat alergi obat');
      //       fBasic.error = true;
      //     } else fBasic.error = false;
      //   } else alergi.push('riwayat alergi obat');

      //   if (this.checkValueData(this.formData['riwayat_alergi_makanan'])) {
      //     let fBasic = this.formBasicData.find(f => f.label == 'ket_riwayat_alergi_makanan');
      //     if (!this.checkValueData(this.formData['ket_riwayat_alergi_makanan']) && this.checkLain('makanan')) {
      //       alergi.push('keterangan riwayat alergi makanan');
      //       fBasic.error = true;
      //     } else fBasic.error = false;
      //   } else alergi.push('riwayat alergi makanan');

      //   if (!this.checkValueData(this.formData['riwayat_alergi_udara'])) alergi.push('riwayat alergi udara');

      //   if (alergi.length > 0) this.click['info_lainnya'] = true;
      // }

      if (
        this.dataTanggal == null ||
        this.selectedKategori == null ||
        card_number ||
        v ||
        alergi.length > 0 ||
        this.keluhan.error
      ) {
        let fErr = [];
        if (!this.selectedKategori) fErr.push("kategori");
        if (card_number) fErr.push("nomor BPJS/NIK Peserta");
        if (!this.dataTanggal) fErr.push("tanggal konsultasi");
        fErr = [...fErr, ...fieldErrors.display(), ...m, ...alergi];
        if (this.keluhan.error) fErr.push(`keluhan ${this.keluhan.message}`);

        fErr = [...new Set(fErr)];
        this.$swal({
          html:  `Oops..! Ada kolom yang belum terisi!<br>Lengkapi kolom ${fErr.join(', ')} sebelum menyimpan data!`,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "OK",
          scrollbarPadding: false
        }).then(res => {
          if (res.value) {
            window.scrollTo({
              top: 160,
              behavior: "smooth"
            });
          }
        });
        if (this.dataTanggal == null) this.validateTanggal = true;
        if (this.selectedKategori == null) this.validateKategori = true;
      } else {
        if (
          !formBasicData.find(item => item.error != null && item.error != false)
        ) {
          this.saveRegister();
        } else {
          this.$swal({
            html: popupErrors,
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "OK",
            scrollbarPadding: false
          }).then(res => {
            if (res.value) {
              window.scrollTo({
                top: 160,
                behavior: "smooth"
              });
            }
          });
        }
      }
    },
    setFormData() {
      return this.setFormBasicData().reduce((arr, val) => {
        const tmp = val.label.split(" ").join("_");
        arr[tmp] = "";
        return arr;
      }, {});
    },
    setFormBasicData() {
      return tmp.map((item, index) => ({
        ...item,
        label: item.label.split(" ").join("_"),
        tmpId: index,
        error: null,
        rawLabel: item.label
      }));
    },
    setDefaultFormBasic(types) {
      this.formBasicData.map(fd => {
        if (types.includes(fd.type)) {
          this.setValue({
            label: fd.label,
            rawLabel: fd.rawLabel,
            $event: null,
          });
        }
      });
    },
    setValue({ label, rawLabel, $event = null } = {}) {
      let value = $event;
      if (typeof $event === "object" && $event != null) {
        if ($event) {
          if ($event.target) {
            const {
              target: { value }
            } = $event;
            this.formData[label] = value;
          } else if ($event.label && $event.value) {
            this.formData[label] = $event;
          }

          if (label == "poliklinik") {
            this.getDokter($event.value);

            this.formData.slot_waktu = "";
            this.formData.nama_dokter = "";
            this.selectedDokter = null;
            this.selectedSlot = null;
            this.selectedDokterMount = {};
            this.selectedSlotMount = {};

            if (this.checkPoliGigi($event.label)) {
              this.isPoliGigi = true
              this.setDefaultFormBasic(['pemeriksaan_fisik','pemeriksaan_lainnya']);
            } else {
              this.isPoliGigi = false
              this.setDefaultFormBasic(['select_penyakit']);
            }
          }

          if (label == "nama_dokter") {
            this.getSlot(
              $event.value,
              this.selectedPoli.value,
              this.dataTanggal
            ).then(() => {
              if (this.option_slot_waktu == undefined) {
                this.formData.slot_waktu = this.isCustomSlot
                  ? this.customSlot.value
                  : "";
                this.selectedSlot = this.isCustomSlot ? this.customSlot : null;
                this.selectedSlotMount = this.isCustomSlot
                  ? this.customSlot
                  : {};
              }
            });
          }

          if (label == "provinsi") {
            this.selectedKota = null;
            this.selectedKotaMount = {};
            this.option_kota = [];
            this.getKota($event.value);
          }

          if (label == "tinggi_badan" || label == "berat_badan") {
            if (
              parseInt(this.formData["tinggi_badan"]) &&
              parseInt(this.formData["berat_badan"])
            ) {
              let tinggi_badan = parseInt(this.formData["tinggi_badan"]) * 0.01;
              let imt =
                parseInt(this.formData["berat_badan"]) /
                (tinggi_badan * tinggi_badan);
              this.formData["IMT"] = imt.toFixed(2);
            } else {
              this.formData["IMT"] = null;
            }
          }

          let dataPasien = {};
          if (label == "nama_pasien") {
            if ($event.target) {
              const {
                target: { value }
              } = $event;
              dataPasien = this.pasiens.find(p => p.id === value);
              this.formData[label] = value;
            } else if ($event.label && $event.value) {
              dataPasien = this.pasiens.find(p => p.id === $event.value);
              this.formData[label] = $event;
            }

            if (dataPasien) {
              this.formData["no._rekam_medis"] = dataPasien["nomor_rekam_medis"];
              this.formData["nomor_handphone"] = dataPasien["nomor_hp"];
              this.formData["jenis_kelamin"] = dataPasien["jenis_kelamin"];
              this.formData["tinggi_badan"] = dataPasien["tinggi_badan"];
              this.formData["berat_badan"] = dataPasien["berat_badan"];
              this.formData["usia_pasien"] = dataPasien["usia_pasien"];
              this.formData["keterangan_lain"] = dataPasien["keterangan_lain"];
              this.formData["alamat_rumah"] = dataPasien["alamat_rumah"] || '';

              if (
                parseInt(dataPasien["tinggi_badan"]) &&
                parseInt(dataPasien["berat_badan"])
              ) {
                let tinggi_badan = parseInt(dataPasien["tinggi_badan"]) * 0.01;
                let imt =
                  parseInt(dataPasien["berat_badan"]) /
                  (tinggi_badan * tinggi_badan);
                this.formData["IMT"] = imt.toFixed(2);
              } else {
                this.formData["IMT"] = null;
              }
            }
          }
        } else if (label == "nama_pasien") {
          this.formData[label] = "";
          this.formData["no._rekam_medis"] = "";
          this.formData["nomor_handphone"] = "";
          this.formData["jenis_kelamin"] = "";
          this.formData["tinggi_badan"] = "";
          this.formData["berat_badan"] = "";
          this.formData["suhu"] = "";
          this.formData["sistole"] = "";
          this.formData["diastole"] = "";
          this.formData["nadi"] = "";
          this.formData["respirasi"] = "";
          this.formData["lingkar_perut"] = "";
          this.formData["usia_pasien"] = "";
          this.formData["keterangan_lain"] = "";
          for (var i = 1; i <= 7; i++) {
            this.formBasicData[i]["error"] = null;
          }
          this.formBasicData[12]["error"] = null;
          this.formBasicData[13]["error"] = null;
        }
      } else {
        this.formData[label] = value;
      }

      this.triggerValidation({
        label,
        $v: this.$v,
        $vm: this,
        rawLabel
      });
      if (label == "nama_pasien") {
        const pasien = find(this.pasiens, {
          id: $event.value
        });
        if (pasien) {
          this.autoFill(pasien, "nama_pasien");
        }
      }

      if (label.includes("ket_")) {
        let f_ket = this.formBasicData.find(f => f.label == label);
        f_ket["error"] = this.setValidationErrorKet(
          label.replace("ket_", ""),
          this.selectedType[f_ket.type],
          this.formData[label]
        );
      } else {
        let f = this.formBasicData.find(f => f.rawLabel == rawLabel);
        if (f && ['select_penyakit','pemeriksaan_fisik','pemeriksaan_lainnya'].includes(f.type)) {
          let x = `ket_${label}`;
          let d = this.formData[label];
          if (
            f &&
            d &&
            d.value != undefined &&
            this.formData.hasOwnProperty(x)
          ) {
            if (d.value != this.selectedType[f.type]) this.formData[x] = null;
            else if (this.editData && d && d.value == this.selectedType[f.type]) this.formData[x] = this.editData.hasOwnProperty(x) ? this.editData[x] : null;
          }
          
          let f_ket = this.formBasicData.find(f => f.label == x);
          if (f_ket) f_ket['error'] = this.setValidationErrorKet(label, this.selectedType[f.type], this.formData[x]);
        }
      }
      if (label == 'ket_riwayat_alergi_makanan') this.alergi['ket_riwayat_alergi_makanan'] = this.formData[label];
      if (label == 'ket_riwayat_alergi_obat') this.alergi['ket_riwayat_alergi_obat'] = this.formData[label];
    },
    setValidationErrorKet(label, type, value) {
      let fd = this.formData[label];
      if (fd && fd.value == type && (!value || value == null || value == '' || value == undefined)) {
        return true;
      } else {
        return false;
      }
    },
    autoFill(pasien, filler) {
      let autoFillForm = {
        nomor_rekam_medis: "no._rekam_medis",
        nama_pasien: "nama_pasien",
        jenis_kelamin: "jenis_kelamin",
        usia_pasien: "usia_pasien",
        nomor_hp: "nomor_handphone",
        tinggi_badan: "tinggi_badan",
        berat_badan: "berat_badan",
        anamnesis: "anamnesis",
        keluhan: "keluhan",
        keterangan_lain: "keterangan_lain",
        alamat_rumah: "alamat_rumah",
        riwayat_penyakit: "riwayat_penyakit",
        riwayat_alergi_obat: "riwayat_alergi_obat",
        ket_riwayat_alergi_obat: "ket_riwayat_alergi_obat",
        riwayat_alergi_makanan: "riwayat_alergi_makanan",
        ket_riwayat_alergi_makanan: "ket_riwayat_alergi_makanan",
        riwayat_alergi_udara: "riwayat_alergi_udara",
        riwayat_alergi_lain: "riwayat_alergi_lain",
        riwayat_pengobatan: "riwayat_pengobatan"
      };

      pasien.usia_pasien = this.checkAge(pasien, "detailed");
      if (pasien.tinggi_badan != undefined)
        pasien.tinggi_badan = pasien.tinggi_badan.toString().replace(".", ",");
      if (pasien.berat_badan != undefined)
        pasien.berat_badan = pasien.berat_badan.toString().replace(".", ",");

      for (let prop in pasien) {
        if (autoFillForm.hasOwnProperty(prop)) {
          if (prop == filler || !autoFillForm[prop] || (prop != "jenis_kelamin" && !pasien[prop])) continue;

          let value = pasien[prop];
          if (!['jenis_kelamin','riwayat_alergi_makanan','riwayat_alergi_udara','riwayat_alergi_obat'].includes(prop)) value = pasien[prop] == 0 ? "" : pasien[prop];

          if (['riwayat_alergi_makanan','riwayat_alergi_udara','riwayat_alergi_obat'].includes(prop)) {
            this.alergi[prop] = value;

            let x = this.typeAlergi[prop];
            this.alergi[x] = pasien[x] || null;
            this.setValueAlergi(prop);
          } else {
            if (['ket_riwayat_alergi_makanan','ket_riwayat_alergi_obat'].includes(prop)) this.alergi[prop] = value;
            
            this.setValue({
              label: autoFillForm[prop],
              rawLabel: autoFillForm[prop].split("_").join(" "),
              $event: value
            });
          }
        }
      }

      if (pasien.provinsi) {
        this.selectedProvinsi = this.selectedProvinsiMount = this.option_provinsi.find(
          p => p.value == pasien.provinsi
        );
        this.setValue({
          rawLabel: "provinsi",
          label: "provinsi",
          $event: this.selectedProvinsi
        });
      }

      if (pasien.kota) {
        let selectedKota = {
          label: pasien.kota_nama,
          value: pasien.kota
        };
        this.selectedKota = this.selectedKotaMount = selectedKota;
        this.setValue({
          rawLabel: "kota",
          label: "kota",
          $event: selectedKota
        });
      }

      if (pasien.golongan_darah) {
        this.selectedBlood = this.selectedBloodMount = this.option_blood.find(
          b => b.value == pasien.golongan_darah
        );
        this.setValue({
          rawLabel: "golongan_darah",
          label: "golongan_darah",
          $event: this.selectedBlood
        });
      }

      if (this.option_gender.map(g => g.value).includes(pasien.jenis_kelamin)) {
        this.selectedGender = this.selectedGenderMount = this.option_gender.find(
          b => b.value == pasien.jenis_kelamin
        );
        this.setValue({
          rawLabel: "jenis_kelamin",
          label: "jenis_kelamin",
          $event: this.selectedGender
        });
      }

      if(pasien.nomor_hp){
        this.setValue({
          rawLabel: "nomor_handphone",
          label: "nomor_handphone",
          $event: pasien.nomor_hp_prefix ? '+' + pasien.nomor_hp_prefix + pasien.nomor_hp : pasien.nomor_hp
        });
      }
    },
    async saveRegister() {
      const postData = this.setDataValue(this.formData);

      try {
        const res = await this.$axios.post(`transaksi`, postData);
        const { status, data, message } = res.data;

        if (status == true) {
          this.beingSubmit = true;

          if (message.includes("satusehat-blm-aktif100x100.png")) {
            this.$swal({
              title: `Data Berhasil disimpan`,
              html: message,
              type: "success",
              showCancelButton: true,
              cancelButtonText: "Lanjutkan",
              confirmButtonText: "Coba Lagi",
              cancelButtonColor: "#1bc943",
              allowOutsideClick: false
            }).then(res => {
              if (res.value) {
                this.syncSatuSehat(data.id);
              } else {
                let today = moment(this.dataTanggal).diff(new Date()) < 0;
                this.$router.push(`/antrean-klinik?today=${today}`);
              }
            });
            return;
          }

          if (message.includes("bpjs-blum-aktif.png")) {
            this.$swal({
              title: `Data Berhasil disimpan`,
              html: message,
              type: "success",
              confirmButtonText: "Lanjutkan",
              confirmButtonColor: "#1bc943",
              allowOutsideClick: false
            }).then(res => {
              let today = moment(this.dataTanggal).diff(new Date()) < 0;
              this.$router.push(`/antrean-klinik?today=${today}`);
            });
            return;
          }

          if (data) {
            const { nomor_antrian } = data;
            const { nama_lengkap } = postData;

            let dateToday = moment(new Date()).format("YYYY-MM-DD");
            let pickTanggal = moment(this.dataTanggal).format("YYYY-MM-DD");

            if (dateToday != pickTanggal) {
              this.$swal({
                title: `Data Berhasil disimpan`,
                type: "success"
              }).then(res => {
                if (res.value) {
                  let today = moment(this.dataTanggal).diff(new Date()) < 0;
                  this.$router.push(`/antrean-klinik?today=${today}`);
                }
              });
            } else {
              this.$swal({
                title: `Data Berhasil disimpan`,
                html: message,
                type: "success"
              }).then(res => {
                if (res.value) {
                  let today = moment(this.dataTanggal).diff(new Date()) < 0;
                  this.$router.push(`/antrean-klinik?today=${today}`);
                }
              });
            }
          } else {
            this.$swal({
              title: `Data Berhasil disimpan`,
              html: message,
              type: "success"
            }).then(res => {
              if (res.value) {
                let today = moment(this.dataTanggal).diff(new Date()) < 0;
                this.$router.push(`/antrean-klinik?today=${today}`);
              }
            });
          }

          this.$router.push({
            path: "/antrean-klinik",
            query: { tab: "today" }
          });
        } else if (status == false) {
          this.$swal({
            html: message,
            type: "warning"
          });
        } else {
          this.$swal({
            html: message,
            type: "error"
          });
        }
      } catch (err) {
        if (this.isOnline) {
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, terjadi gangguan sistem.",
            type: "error",
            confirmButtonText: "OK"
          });
        } else {
          this.$swal({
            title: "Oops...",
            text: "Gagal memuat data, periksa koneksi Anda kembali.",
            type: "error",
            showCancelButton: true,
            cancelButtonText: "Batal",
            confirmButtonText: "Coba Lagi"
          }).then(res => {
            if (res.value) {
              this.saveRegister();
            }
          });
        }
      }
    },
    async syncSatuSehat(id) {
      const res = await this.$axios.put(
        `satu-sehat/transklinik/sync/${id}?klinik_id=${this.getKlinikId}`
      );
      const { status, message, data } = res.data;

      if (status) {
        this.$swal({
          html: message,
          type: "warning",
          confirmButtonText: "OK"
        }).then(async res => {
          if (res.value) {
            let today = moment(this.dataTanggal).diff(new Date()) < 0;
            this.$router.push(`/antrean-klinik?today=${today}`);
          }
        });
        return;
      }
      this.$swal({
        html: message,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Lanjutkan",
        confirmButtonText: "Coba Lagi",
        cancelButtonColor: "#1bc943",
        allowOutsideClick: false
      }).then(async res => {
        if (res.value) {
          await this.syncSatuSehat(id);
        } else {
          let today = moment(this.dataTanggal).diff(new Date()) < 0;
          this.$router.push(`/antrean-klinik?today=${today}`);
        }
      });
    },
    debounceSearchPasien: debounce(function(val) {
      this.searchPasien(val);
    }, 500),
    async searchPasien(val, id = "") {
      try {
        if (id != "") id = `&id=${id}`;
        const res = await this.$axios.get(
          `transaksi/list-pasien?klinik_id=${this.getKlinikId}&limit=100&nama_pasien=${val}&with_parent=1${id}`
        );

        this.pasiens = res.data.data.data;
        this.options.nama_pasien = this.pasiens.map(item => {
          let disable = false;
          if (this.satusehatAuthValid) {
            if (
              item.synced_to_satusehat &&
              item.satusehat_patient_id != null &&
              item.satusehat_patient_id != ""
            )
              disable = false;
            else disable = true;
          }
          return {
            label: `${item.nama}`,
            value: item.id,
            disable: disable
          };
        });
      } catch (err) {}
    },
    async cekPesertaBPJS() {
      this.disableDate = false;

      this.card_number.error = this.cekCardNumber();
      if (this.card_number.error) return;

      const res = await this.$axios.post(`bpjs/peserta`, {
        klinik_id: this.getKlinikId,
        card_number: this.card_number.number
      });
      const { status, data } = res.data;

      if (!status) {
        this.isErrorKategori = true;
        this.dataPasien = false;
        this.disableDate = true;

        this.$swal({
          text: "Gagal cek data peserta",
          type: "error",
          showCancelButton: false,
          confirmButtonText: "OK"
        });
        return;
      }

      if (!data.aktif) {
        this.disableDate = true;
        this.$swal({
          html: `Peserta tidak aktif <br> Keterangan: ${data.ketAktif}`,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "OK"
        });
        return;
      }

      this.activeBPJS = true;
      this.dataBPJSSuccess = true;
      this.dataBPJS = data;

      if (typeof data.notInFktpMessage == "string") {
        if (data.notInFktpMessage.includes("FKTP")) {
          this.isErrorKategori = true;
          this.$swal({
            html:
              '<div class="swal2-icon swal2-question swal2-icon-show" style="display: flex;"></div><b>Peserta tidak terdaftar di FKTP Anda!</b><p>Apakah Anda akan melanjutkan proses antrean?</p>',
            showCancelButton: true,
            confirmButtonText: "Ya, Lanjutkan",
            cancelButtonText: "Tidak",
            cancelButtonColor: "#f83245",
            reverseButtons: true
          }).then(res => {
            if (res.value) {
              this.isErrorKategori = false;
            } else {
              this.dataBPJS = {
                detail_peserta: {
                  nama: null,
                  pstProl: null,
                  sex: null,
                  tglLahir: null,
                  hubunganKeluarga: null,
                  noHP: null,
                  kdProviderPst: {
                    kdProvider: null,
                    nmProvider: null
                  }
                }
              };
              this.dataBPJSSuccess = false;
            }
          });
          return;
        }
      }

      if (data.aktif) {
        if (data.pasien_id) {
          await this.setSelectedPasien(data.pasien_id);
        }

        this.isErrorKategori = false;
        this.$swal({
          text: "Peserta aktif",
          type: "success",
          showCancelButton: false,
          confirmButtonText: "OK"
        });
      } else {
        this.isErrorKategori = true;
        this.$swal({
          html: `Peserta tidak aktif <br> Keterangan: ${data.ketAktif}`,
          type: "warning",
          showCancelButton: false,
          confirmButtonText: "OK"
        });
      }
    },
    async setSelectedPasien(pasien_id) {
      const res = await this.$axios.get(
        `pasien/${pasien_id}?klinik_id=${this.getKlinikId}`
      );
      const { status, data } = res.data;

      if (status) {
        const pasien = {
          label: data.nama,
          value: data.id,
          tanggal_lahir: data.tanggal_lahir,
          age_year: data.age_year,
          age_month: data.age_month,
          age_day: data.age_day,
          jenis_kelamin: data.jenis_kelamin
        };

        this.selectedPasien = pasien;
        this.options.nama_pasien = [{ ...pasien, disable: true }];
        this.pasiens = [
          {
            id: data.id,
            nama: data.nama,
            nomor_rekam_medis: data.nomor_rekam_medis,
            nomor_hp: data.nomor_hp,
            tanggal_lahir: data.tanggal_lahir,
            jenis_kelamin: data.jenis_kelamin,
            tinggi_badan: data.tinggi_badan,
            berat_badan: data.berat_badan,
            suhu: data.suhu,
            tensi_sistole: data.tensi_sistole,
            tensi_diastole: data.tensi_diastole,
            nadi: data.nadi,
            respirasi: data.respirasi,
            lingkar_perut: data.lingkar_perut,
            imt: data.imt,
            keterangan_lain: data.keterangan_lain,
            umur: data.umur,
            anamnesis: data.anamnesa || null,
            keluhan: data.keluhan || null,
          }
        ];

        if (data) {
          this.formData["nama_pasien"] = pasien;
          this.formData["no._rekam_medis"] = data["nomor_rekam_medis"];
          this.formData["nomor_handphone"] = data["nomor_hp"];
          this.formData["jenis_kelamin"] = data["jenis_kelamin"];
          this.formData["tinggi_badan"] = data["tinggi_badan"];
          this.formData["berat_badan"] = data["berat_badan"];
          this.formData["usia_pasien"] =
            (data["age_year"] || 0) +
            " tahun " +
            (data["age_month"] || 0) +
            " bulan " +
            (data["age_day"] || 0) +
            " hari";
          this.formData["keterangan_lain"] = data["keterangan_lain"];
          this.formData["anamnesis"] = data.anamnesa ? data.anamnesa.replace(/<\/?[^>]+(>|$)/g, "") : null;
          this.formData["keluhan"] = data.keluhan || null;

          if (parseInt(data["tinggi_badan"]) && parseInt(data["berat_badan"])) {
            let tinggi_badan = parseInt(data["tinggi_badan"]) * 0.01;
            let imt =
              parseInt(data["berat_badan"]) / (tinggi_badan * tinggi_badan);
            this.formData["IMT"] = imt.toFixed(2);
          } else {
            this.formData["IMT"] = null;
          }

          let kota = data.kota;
          if (kota && typeof kota == 'object') {
            kota = {
              kota: kota.id,
              kota_nama: kota.nama,
            }
          }

          let dataPasien = {
            ...data,
            ...kota,
            provinsi: data.provinsi && typeof data.provinsi == 'object' ? data.provinsi.id : data.provinsi,
          }
          this.autoFill(dataPasien, "nama_pasien");
        }
      }
    },
    cekCardNumber() {
      let result = false;
      let number = this.card_number.number;
      if (number == "" || number == null || number == undefined) {
        result = true;
      } else {
        if (number.length == 13 || number.length == 16) {
          result = false;
        } else {
          result = true;
        }
      }
      return result;
    },
    onKeyInputNumberBPJS({ $event }) {
      var evt = $event;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },
    onCardNumber() {
      this.card_number.error = this.cekCardNumber();
      this.card_number.message = "Nomor tidak sesuai";
    },
    disableInput(label) {
      return label == "nomor_handphone" ? false : true;
    },
    checkSelectedAda() {
      const { formData, formBasicData } = this;
      const type = {select_penyakit: 'Y', pemeriksaan_fisik: 'Y', pemeriksaan_lainnya: 'L'};
      for (let i in formData) {
        let f = formBasicData.find(f => f.label == i);
        if (f && f != undefined && i.includes("ket_")) {
          f["error"] = false;
          let x = i.replace("ket_", "");
          if (
            formData[x] &&
            typeof formData[x] == 'object' &&
            formData[x].value == type[f.type] &&
            (!formData[i] || formData[i] == "" || formData[i] == undefined)
          ) {
            f["error"] = true;
          }
        }
      }

      let err = [];
      formBasicData.forEach(f => {
        if (f.error && f.error == true && f.label.includes("ket_"))
          err.push(f.label);
      });
      if (err.length > 0) {
        return {
          v: true,
          m: err
            .join(", ")
            .replace(/ket_/g, "keterangan ")
            .replace(/_/g, " ")
            .split(", ")
        };
      }
      return { v: false, m: "" };
    },
    setPemeriksaanFisik(data) {
      let pemeriksaan = tmp.filter(
        t => t.type == "pemeriksaan_fisik" || t.type == "pemeriksaan_lainnya"
      );
      let options = {
        pemeriksaan_fisik: this.option_pemeriksaan_fisik,
        pemeriksaan_lainnya: this.option_pemeriksaan_lainnya
      };
      pemeriksaan.forEach(r => {
        let i = r.label.replace(/ /g, "_");
        if (data.hasOwnProperty(i)) {
          if (
            i.includes("ket_") ||
            ["luas_fisik", "sosial_ekonomi", "spiritual"].includes(i)
          ) {
            this.formData[i] = data[i] || null;
          } else {
            if (options[r.type])
              this.formData[i] =
                options[r.type].find(r => r.value == data[i]) || null;
          }
          if (data[i]) {
            this.setValue({
              label: i,
              rawLabel: r.label,
              $event: this.formData[i]
            });
          }
        }
      });
    },
    setRiwayatPenyakit(data) {
      let riwayat = tmp.filter(t => t.type == "select_penyakit");
      riwayat.forEach(r => {
        let i = r.label.replace(/ /g, "_");
        if (data.hasOwnProperty(i)) {
          if (i == "ket_penyakit_lainnya") {
            this.formData[i] = data[i] || null;
          } else {
            this.formData[i] =
              this.option_penyakit.find(r => r.value == data[i]) || null;
          }
          if (data[i]) {
            this.setValue({
              label: i,
              rawLabel: r.label,
              $event: this.formData[i]
            });
          }
        }
      });
    },
    setDataValue(data) {
      let result = {};
      for (let i in data) {
        if (i != "") {
          if (data[i]) {
            result[i] = typeof data[i] == "object" ? data[i].value : data[i];
          } else {
            let dataNull = null;
            if (
              [
                "tinggi_badan",
                "berat_badan",
                "suhu",
                "sistole",
                "diastole",
                "nadi",
                "respirasi",
                "lingkar_perut",
                "imt",
                "IMT"
              ].includes(i)
            ) {
              dataNull = 0;
            }
            result[i] =
              !data[i] ||
              data[i] == "" ||
              data[i] == null ||
              data[i] == undefined
                ? dataNull
                : data[i];
          }
        }
      }

      let riwayat = {};
      if (this.pcareVersion == '1') {
        if (this.checkValueData(data.riwayat_alergi_makanan)) {
          riwayat['riwayat_alergi_makanan'] = data.riwayat_alergi_makanan.label || null;
          riwayat['alergi_makanan_bpjs'] = data.riwayat_alergi_makanan.value || null;
        }
        if (this.checkValueData(data.riwayat_alergi_obat)) {
          riwayat['riwayat_alergi_obat'] = data.riwayat_alergi_obat.label || null;
          riwayat['alergi_obat_bpjs'] = data.riwayat_alergi_obat.value || null;
        }
        if (this.checkValueData(data.riwayat_alergi_udara)) {
          riwayat['riwayat_alergi_udara'] = data.riwayat_alergi_udara.label || null;
          riwayat['alergi_udara_bpjs'] = data.riwayat_alergi_udara.value || null;
        }
      }

      const waktu_konsultasi = this.formData.waktu_konsultasi;
      result = {
        ...result,
        ...riwayat,
        id: this.isTambah ? null : this.antrean_id,
        klinik_id: this.getKlinikId || null,
        kategori_id: this.selectedKategori.value || null,
        pasien_id: this.formData.nama_pasien.value || null,
        poli_id: this.selectedPoli.value || null,
        dokter_id: this.selectedDokter.value || null,
        no_urut: this.selectedSlot.no_urut || null,
        slot: this.selectedSlot.value || null,
        bpjs_noka: this.dataBPJS
          ? this.dataBPJS.noKartu
          : this.nokaBpjs
          ? this.nokaBpjs
          : null,
        kdProvider: this.dataBPJS ? this.dataBPJS.kdProvider : null,
        nomor_rekam_medis: this.formData["no._rekam_medis"] || null,
        nama_lengkap: this.formData.nama_pasien.label || null,
        nomor_telp: this.formData.nomor_handphone || null,
        waktu_konsultasi:
          (waktu_konsultasi &&
            waktu_konsultasi.toLowerCase() &&
            waktu_konsultasi === "invalid date" &&
            null) ||
          waktu_konsultasi,
        provinsi: this.selectedProvinsi ? this.selectedProvinsi.value : null,
        kota: this.selectedKota ? this.selectedKota.value : null,
        golongan_darah: this.selectedBlood ? this.selectedBlood.value : null,
        jenis_kelamin: this.selectedGender ? this.selectedGender.value : null
      };
      return result;
    },
    setLabel(val) {
      let label = "";
      switch (val) {
        case "nomor handphone":
          label = "No. Handphone";
          break;
        case "saturasi oksigen":
          label = "SpO2";
          break;
        case "riwayat alergi lain":
          label = "Riwayat Alergi Lain-Lain";
          break;
        case "anus":
          label = "Anus/Dubur";
          break;
        case "luas fisik":
          label = "Luas Permukaan Tubuh untuk Anak-Anak";
          break;
        case "langit langit":
          label = "Langit-Langit";
          break;
        case "anamnesis":
          label = "Anamnesa";
          break;
        default:
          label = val;
          break;
      }
      return label;
    },
    checkLain(type) {
      if (this.pcareVersion == '1' && this.checkValueData(this.formData[`riwayat_alergi_${type}`])) {
        let value = this.formData[`riwayat_alergi_${type}`].label;
        if (value && value.toLowerCase().includes('lain')) {
          this.formData[`ket_riwayat_alergi_${type}`] = this.alergi[`ket_riwayat_alergi_${type}`];
          return true;
        } else if (this.formData.hasOwnProperty(`ket_riwayat_alergi_${type}`)) this.formData[`ket_riwayat_alergi_${type}`] = null;
      }
      return false;
    },
    checkFormAlergiPcare(rawLabel) {
      return this.pcareVersion == '1' && [
        'riwayat alergi makanan',
        'riwayat alergi udara',
        'riwayat alergi obat',
      ].includes(rawLabel);
    },
    setValueAlergi(key) {
      let value = null;
      let kategori = this.selectedKategori ? this.selectedKategori.value : null;
      let x = this.typeAlergi[key];
      if (this.alergi[key]) {
        if (this.optAlergi[key].length > 0 && kategori == 2) value = this.optAlergi[key].find(opt => opt.value == this.alergi[x]);
        else value = this.alergi[key];
      }

      this.setValue({
        label: key,
        rawLabel: key.split("_").join(" "),
        $event: value,
      });
    },
    checkKeluhan(val, label) {

      let kategori = this.checkValueData(this.selectedKategori) && this.selectedKategori.value;
      if (kategori != 2) return;

      if (label == 'keluhan') {
        if (this.checkValueData(val) && (val.trim().length < 4 || val.trim().length > 255)) {
          this.keluhan.error = true;
          this.keluhan.message = 'minimal 4 karakter, maksimal 255 karakter';

          return true
        } else {
          this.keluhan.error = false;
          this.keluhan.message = null;
        }
      }

      if (label == 'anamnesis') {
        if (this.checkValueData(val) && (val.trim().length < 10 || val.trim().length > 255)) {
          this.anamnesis.error = true;
          this.anamnesis.message = 'minimal 10 karakter, maksimal 255 karakter';

          return true
        } else {
          this.anamnesis.error = false; 
          this.anamnesis.message = null;
        }
      }
    },
    checkTanda(val, label) {

      let kategori = this.checkValueData(this.selectedKategori) && this.selectedKategori.value;
      if (kategori != 2) return;

      if (label == 'berat_badan') {
        if (this.checkValueData(val) && (val < 2 || val > 300)) {
          this.berat_badan.error = true;
          this.berat_badan.message = 'minimal 2 Kg, maksimal 300 Kg';

          return true
        } else {
          this.berat_badan.error = false;
          this.berat_badan.message = null;
        }
      }

      if (label == 'tinggi_badan') {
        if (this.checkValueData(val) && (val < 30 || val > 210)) {
          this.tinggi_badan.error = true;
          this.tinggi_badan.message = 'minimal 30 Cm, maksimal 210 Cm';

          return true
        } else {
          this.tinggi_badan.error = false; 
          this.tinggi_badan.message = null;
        }
      }
      
      if (label == 'sistole') {
        if (this.checkValueData(val) && (val < 40 || val > 250)) {
          this.sistole.error = true;
          this.sistole.message = 'minimal 40 MmHg, maksimal 250 MmHg';

          return true
        } else {
          this.sistole.error = false; 
          this.sistole.message = null;
        }
      }

      if (label == 'diastole') {
        if (this.checkValueData(val) && (val < 30 || val > 180)) {
          this.diastole.error = true;
          this.diastole.message = 'minimal 30 MmHg, maksimal 180 MmHg';

          return true
        } else {
          this.diastole.error = false; 
          this.diastole.message = null;
        }
      }

      if (label == 'nadi') {
        if (this.checkValueData(val) && (val < 30 || val > 160)) {
          this.nadi.error = true;
          this.nadi.message = 'minimal 30x, maksimal 160x';

          return true
        } else {
          this.nadi.error = false; 
          this.nadi.message = null;
        }
      }

      if (label == 'respirasi') {
        if (this.checkValueData(val) && (val < 5 || val > 70)) {
          this.respirasi.error = true;
          this.respirasi.message = 'minimal 5x, maksimal 70x';

          return true
        } else {
          this.respirasi.error = false; 
          this.respirasi.message = null;
        }
      }
    },
  }
};
</script>

<style scoped>
.mb-6 {
  margin-bottom: 2.7em;
}

.polaris-card {
  border: 1px solid #cdcdcd;
  border-radius: 10px;
  padding: 20px;
}

.border-red {
  border-color: red;
}
</style>

<style lang="scss">
.icon_sync {
  width: 60px;
  height: fit-content;
}

.__antrean-select
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
  font-size: 12px !important;
  font-weight: 500;
}

#select_nama_pasien .no-overflow,
#id_select_poliklinik .no-overflow,
#id_select_kota .no-overflow,
#id_select_dokter .no-overflow {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#select_nama_pasien .vs__selected-options,
#id_select_poliklinik .vs__selected-options,
#id_select_kota .vs__selected-options,
#id_select_dokter .vs__selected-options {
  width: 80%;
}

#select_nama_pasien .vs__selected-options .vs__selected,
#id_select_poliklinik .vs__selected-options .vs__selected,
#id_select_kota .vs__selected-options .vs__selected,
#id_select_dokter .vs__selected-options .vs__selected {
  width: 87%;
}

.__kategori-select
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search::placeholder {
  color: #d1d2db !important;
  font-weight: 500;
}

.outer_antrian {
  position: relative;
  border-radius: 15px;
  border: 1px solid #0c5cd4;
  outline-color: #0c5cd4;
  outline-width: thin;
}

.__antrean_blue {
  padding: 18px;
  color: white;
  border-radius: 8px;
  background-color: #4896e8;
  cursor: pointer;
}

.v-select {
  & > .vs__dropdown-toggle {
    min-height: 41.75px !important;
  }

  &.error {
    & > .vs__dropdown-toggle {
      border-color: red;
    }
  }
}

.error {
  color: red;
  margin-top: 3px;
}

.invalid_msg {
  width: 100%;
  margin-top: 0.85rem;
  font-size: 80%;
  color: #f83245;
}

.icon_cal {
  position: absolute;
  left: 89%;
  top: 12px;
  color: gray;
}

.icon_cal_err {
  position: absolute;
  left: 89%;
  top: 12px;
  color: gray;
}

.custom_append {
  height: 42px;
  margin-top: 8px;
  background-color: #eeeff8;
}

.top_form {
  top: -10px;
}

.top_form_err {
  top: -1px;
}

@media only screen and (max-width: 1400px) {
  .icon_cal {
    position: absolute;
    left: 89%;
    top: 12px;
    color: gray;
  }

  .icon_cal_err {
    position: absolute;
    left: 89%;
    top: 12px;
    color: gray;
  }

  .top_form {
    top: -13px;
  }

  .top_form_err {
    top: 0px;
  }

  .invalid_msg {
    width: 100%;
    margin-top: 0.85rem;
    font-size: 70%;
    color: #f83245;
  }
}
</style>
